import { JSX } from 'react'

import { IconProps } from '../../icon'

const Show: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 96}
    id={id}
    stroke={stroke}
    viewBox='0 0 211 210'
    width={width || 96}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <g clipPath='url(#clip0_2308_2914)'>
      <mask
        id='mask0_2308_2914'
        // style='mask-type:luminance'
        maskUnits='userSpaceOnUse'
        x='1'
        y='0'
        width='210'
        height='210'
      >
        <path d='M210.454 0H1V210H210.454V0Z' fill='white' />
      </mask>
      <g mask='url(#mask0_2308_2914)'>
        <path
          d='M215.918 65.1128L215.28 95.6201L187.96 83.0529C187.596 81.778 183.407 65.0217 197.158 56.4614L215.918 65.1128Z'
          fill='#FBCE86'
        />
        <path
          d='M184.773 50.8153L196.065 56.0061C183.589 64.2021 185.957 78.9549 186.776 82.5976L175.666 77.4979C175.484 76.8604 175.029 74.8569 174.846 72.1249C174.573 66.2056 175.666 56.6436 184.773 50.8153Z'
          fill='white'
        />
        <path
          d='M169.291 46.8084C171.841 48.1744 179.764 51.726 181.312 52.3634C174.938 58.1006 173.845 66.0234 174.027 71.4874C172.661 70.7589 169.109 68.9376 165.284 67.6626C162.826 66.843 161.369 67.1163 159.456 67.4805C159.092 67.5716 158.728 67.5716 158.363 67.6626C156.451 67.9358 153.901 68.209 149.712 67.6626C143.793 66.843 140.241 64.111 138.42 62.1986L139.786 56.4614C140.696 56.0061 141.516 55.2775 142.245 54.4579C142.427 54.2758 142.7 54.0027 142.882 53.8205C143.611 53.092 144.43 52.3634 145.341 52.1813C148.164 51.6349 150.805 51.817 153.537 52.8188C156.542 53.9116 162.006 53.183 164.192 48.3565C164.283 48.1744 164.192 47.8101 164.01 47.719C163.827 47.628 163.463 47.719 163.372 47.9012C161.369 52.2724 156.542 52.8188 153.81 51.817C150.896 50.7242 148.073 50.5421 145.068 51.1796C143.702 51.4528 142.609 52.5456 141.516 53.6384C140.332 54.8223 139.239 55.915 137.873 55.7329C135.597 55.2776 135.961 51.9081 135.961 51.9081C135.961 51.9081 135.961 51.9081 135.961 51.817C136.416 47.4458 139.695 45.8066 142.882 44.1674C144.43 43.4389 145.887 42.7104 146.98 41.7086C147.982 40.798 148.71 39.8873 149.348 39.0677C150.805 36.8821 151.078 35.1518 151.078 35.0607C151.078 34.7875 150.896 34.6054 150.714 34.5144C150.532 34.5144 150.35 34.6054 150.258 34.7875L155.54 28.6861C156.724 29.5967 157.726 30.5074 158.728 31.5091C161.915 34.7875 164.101 38.6124 165.831 41.7086C167.197 44.3496 168.199 46.1709 169.291 46.8084Z'
          fill='#FCE8D0'
        />
        <path
          d='M166.286 14.3886C166.286 14.7529 166.195 15.2082 165.922 15.4814L155.358 27.5933C154.994 27.3201 154.63 27.0469 154.265 26.8647C153.81 26.5915 153.264 26.3183 152.808 26.0451L163.736 13.4779C164.01 13.2047 164.374 13.0226 164.738 13.0226H164.829C165.193 13.0226 165.558 13.1137 165.831 13.3869C166.013 13.6601 166.195 14.0243 166.286 14.3886Z'
          fill='white'
        />
        <path
          d='M158.546 7.83179C158.637 8.19605 158.637 8.56033 158.455 8.9246L150.532 25.0434C149.621 24.6791 148.619 24.3149 147.709 24.0417L155.723 7.64967C155.905 7.2854 156.178 7.01219 156.542 6.92112C156.724 6.83005 156.906 6.83005 156.998 6.83005C157.18 6.83005 157.453 6.83006 157.635 7.01219C158.181 7.19433 158.455 7.46752 158.546 7.83179Z'
          fill='white'
        />
        <path
          d='M155.267 27.5933L154.63 28.3218C154.265 28.1396 153.992 27.8665 153.628 27.6843C153.082 27.3201 152.535 27.0469 151.989 26.7737L152.626 26.0451C153.082 26.3183 153.628 26.5915 154.083 26.8647C154.539 27.1379 154.903 27.3201 155.267 27.5933Z'
          fill='white'
        />
        <path
          d='M154.721 28.3218L144.157 40.4337L149.166 30.1431L152.08 26.7737C152.626 27.0469 153.173 27.3201 153.719 27.6843C153.992 27.8665 154.356 28.0486 154.721 28.3218Z'
          fill='white'
        />
        <path
          d='M150.623 25.0434L150.258 25.863C149.348 25.4988 148.346 25.1345 147.435 24.8613L147.8 24.0417C148.71 24.406 149.712 24.6791 150.623 25.0434Z'
          fill='white'
        />
        <path
          d='M150.258 25.863L148.437 29.5968L144.885 33.6948L146.434 26.9558L147.435 24.8613C148.346 25.1345 149.257 25.4988 150.258 25.863Z'
          fill='white'
        />
        <path
          d='M150.167 34.9697C150.167 34.9697 150.076 35.0607 150.076 35.1518C150.076 35.1518 149.621 38.2481 146.343 41.1622C145.432 41.9818 144.157 42.6193 142.882 43.2567L150.167 34.9697Z'
          fill='#FCE8D0'
        />
        <path
          d='M148.892 5.64618C149.712 5.82831 150.167 6.64791 149.985 7.46751L146.252 23.6774C145.25 23.4042 144.339 23.2221 143.337 23.131L147.071 6.83004C147.162 6.46577 147.435 6.1015 147.709 5.91937C147.982 5.73723 148.255 5.73725 148.528 5.73725C148.619 5.64618 148.71 5.64618 148.892 5.64618Z'
          fill='white'
        />
        <path
          d='M149.166 30.1431L144.157 40.4337L142.973 41.7086L147.982 31.4181L149.166 30.1431Z'
          fill='white'
        />
        <path
          d='M147.982 31.4181L142.973 41.7086L143.428 39.7962L146.889 32.7841L147.982 31.4181Z'
          fill='white'
        />
        <path
          d='M146.889 32.7841L143.428 39.7962L144.43 35.6071L146.889 32.7841Z'
          fill='white'
        />
        <path
          d='M146.434 26.9558L144.886 33.6947L144.248 34.4233L145.523 28.7771L146.434 26.9558Z'
          fill='white'
        />
        <path
          d='M146.252 23.6774L146.069 24.5881C145.068 24.3149 144.066 24.1327 143.155 24.0417L143.337 23.131C144.248 23.2221 145.25 23.4042 146.252 23.6774Z'
          fill='white'
        />
        <path
          d='M146.069 24.497L145.614 26.5916L139.877 38.4302L143.246 23.9506C144.066 24.1328 145.068 24.3149 146.069 24.497Z'
          fill='white'
        />
        <path
          d='M145.523 28.7771L144.248 34.4233L143.611 35.1518L144.612 30.5985L145.523 28.7771Z'
          fill='white'
        />
        <path
          d='M144.612 30.5984L143.611 35.1518L140.879 38.2481L144.612 30.5984Z'
          fill='white'
        />
        <path
          d='M144.43 35.6071L143.428 39.7962L142.518 41.6176L143.793 36.3357L144.43 35.6071Z'
          fill='white'
        />
        <path
          d='M143.793 36.3357L142.518 41.6176L141.88 43.0746L141.698 43.1657L143.155 37.0642L143.793 36.3357Z'
          fill='white'
        />
        <path
          d='M143.428 39.7962L142.973 41.7086L142.336 42.4372L142.518 41.6176L143.428 39.7962Z'
          fill='white'
        />
        <path
          d='M143.155 37.0642L141.698 43.2568L140.605 44.4407C139.877 44.8049 139.239 45.2602 138.602 45.7156C138.42 45.8066 138.238 45.9888 138.056 46.1709C138.056 46.1709 138.056 46.1709 137.964 46.1709L138.875 42.3461L139.33 41.3444L143.155 37.0642Z'
          fill='white'
        />
        <path
          d='M142.518 41.6176L142.336 42.4371L141.88 43.0746L142.518 41.6176Z'
          fill='white'
        />
        <path
          d='M142.245 23.8595L138.511 39.8873C138.966 36.791 138.875 33.8769 138.875 33.6947C138.875 33.4215 138.602 33.2394 138.42 33.2394C138.147 33.2394 137.965 33.4215 137.965 33.6947C137.965 33.7858 138.238 39.1587 136.781 42.8925L133.229 46.9905C132.409 47.4458 131.499 47.719 130.679 47.719C129.495 47.719 128.585 47.2637 127.947 46.5351C127.036 45.3513 128.038 43.621 128.949 41.9818C129.586 40.889 130.133 39.8873 130.133 39.0677C130.133 38.5213 129.951 37.7017 129.586 36.6089C129.404 35.9714 129.222 35.2429 129.04 34.4233V34.3322C128.494 31.7823 128.22 28.8682 129.86 26.8647C131.59 24.5881 136.507 23.3131 142.245 23.8595Z'
          fill='#FCE8D0'
        />
        <path
          d='M139.33 41.4354L138.875 42.3461L138.966 41.7997L139.33 41.4354Z'
          fill='white'
        />
        <path
          d='M130.406 142.975L139.148 147.164C136.872 147.528 134.595 148.075 132.227 148.712H132.136C113.012 154.085 90.4276 167.29 80.8656 173.209C88.5152 166.561 105.818 152.446 123.758 144.614C125.579 143.794 127.401 143.066 129.222 142.428L130.406 142.975Z'
          fill='#D1E7F0'
        />
        <path
          d='M138.966 41.7997L138.875 42.3461L137.964 44.1674L138.329 42.5282L138.966 41.7997Z'
          fill='white'
        />
        <path
          d='M138.875 42.3461L137.964 46.1709C137.782 46.353 137.6 46.5352 137.418 46.7173L137.964 44.1674L138.875 42.3461Z'
          fill='white'
        />
        <path
          d='M138.602 56.7346L137.509 61.288C137.236 60.9237 136.963 60.5594 136.872 60.3773C138.238 58.7381 138.42 57.4632 138.329 56.7346C138.42 56.8257 138.511 56.8257 138.602 56.7346Z'
          fill='white'
        />
        <path
          d='M138.329 42.5282L137.964 44.1674L137.054 45.9887L137.509 44.0763L138.147 42.7103L138.329 42.5282Z'
          fill='white'
        />
        <path
          d='M138.238 56.8257C138.329 57.5543 138.147 58.8292 136.781 60.4684C136.69 60.2863 136.599 60.1952 136.599 60.1952C136.507 60.0131 136.234 59.922 135.961 60.0131C135.961 60.0131 135.87 60.013 135.87 60.1041C137.509 58.3738 137.327 57.0989 137.236 56.6436C137.327 56.6436 137.418 56.7346 137.509 56.7346C137.782 56.8257 138.056 56.8257 138.238 56.8257Z'
          fill='white'
        />
        <path
          d='M138.147 42.7104L137.509 44.0764L137.691 43.2567L138.147 42.7104Z'
          fill='white'
        />
        <path
          d='M137.965 44.1674L137.418 46.7173C137.236 46.8994 136.963 47.1726 136.781 47.4458L137.145 45.9887L137.965 44.1674Z'
          fill='white'
        />
        <path
          d='M137.691 43.2567L137.509 44.0764L133.866 51.5439C133.684 51.5439 133.593 51.5438 133.411 51.4528L136.143 45.8066C136.234 45.7156 136.325 45.5334 136.416 45.4424C136.872 44.896 137.236 44.1674 137.509 43.4389L137.691 43.2567Z'
          fill='white'
        />
        <path
          d='M137.6 43.4389C137.327 44.1674 136.963 44.896 136.507 45.4424C136.416 45.5335 136.325 45.7156 136.234 45.8066L137.054 44.0764L137.6 43.4389Z'
          fill='white'
        />
        <path
          d='M137.509 44.0764L137.054 45.9887L134.322 51.5438C134.14 51.5438 134.048 51.5438 133.866 51.4527L137.509 44.0764Z'
          fill='white'
        />
        <path
          d='M137.509 61.3791L137.236 62.4719C136.689 61.9255 136.416 61.4701 136.143 61.1059C136.325 61.0148 136.507 60.8326 136.598 60.7416C136.689 60.6505 136.781 60.5595 136.781 60.4684C136.963 60.6505 137.236 60.9237 137.509 61.3791Z'
          fill='white'
        />
        <path
          d='M137.327 56.6436C137.418 57.0989 137.509 58.2828 135.961 60.1041C135.688 60.4684 135.141 60.6505 134.595 60.8326L134.959 59.1024L136.416 56.1882C136.689 56.3704 136.963 56.5525 137.327 56.6436Z'
          fill='white'
        />
        <path
          d='M137.236 62.4719L121.846 128.951L119.205 127.311L134.322 61.9254C135.05 61.7433 135.688 61.4701 136.143 61.1969C136.416 61.4701 136.781 61.9255 137.236 62.4719Z'
          fill='white'
        />
        <path
          d='M132.318 149.623L137.236 150.716C124.031 153.174 98.1682 165.286 84.7814 171.843C95.5273 165.468 115.289 154.449 132.318 149.623Z'
          fill='#FCE9D5'
        />
        <path
          d='M137.054 45.9888L136.69 47.4458C135.961 48.3565 135.415 49.3583 135.141 50.7243L134.413 51.6349L137.054 45.9888Z'
          fill='white'
        />
        <path
          d='M137.054 44.0764L136.234 45.8066C135.506 46.6262 134.686 47.3547 133.775 47.8101L137.054 44.0764Z'
          fill='white'
        />
        <path
          d='M136.872 60.4684C136.781 60.5595 136.689 60.6505 136.689 60.7416C136.598 60.8326 136.416 61.0148 136.234 61.1059C136.052 60.8327 135.961 60.6505 135.961 60.6505C135.87 60.4684 135.87 60.2862 136.052 60.1041L136.143 60.013C136.325 59.922 136.689 60.0131 136.781 60.1952C136.689 60.1952 136.781 60.2862 136.872 60.4684Z'
          fill='white'
        />
        <path
          d='M136.143 45.8066L133.411 51.4527C132.683 51.3617 131.954 51.1796 131.043 50.9064L133.775 47.8101C134.686 47.2637 135.506 46.6262 136.143 45.8066Z'
          fill='white'
        />
        <path
          d='M135.87 60.6505C135.87 60.7416 135.961 60.8327 136.143 61.1059C135.688 61.4701 135.05 61.7433 134.322 61.8344L134.595 60.8326C135.141 60.6505 135.688 60.3773 135.961 60.1041C135.87 60.2862 135.779 60.4684 135.87 60.6505Z'
          fill='white'
        />
        <path
          d='M135.779 55.4597L135.05 57.0079L135.506 55.0044C135.506 55.1865 135.688 55.3687 135.779 55.4597Z'
          fill='white'
        />
        <path
          d='M135.506 55.0044L135.05 57.0079L134.14 58.8292L135.232 54.2758C135.232 54.549 135.324 54.7312 135.506 55.0044Z'
          fill='white'
        />
        <path
          d='M135.141 54.2759L134.049 58.8292L132.956 61.1059C132.136 61.1969 131.225 61.1058 130.315 61.0148C130.133 61.0148 129.951 60.9237 129.768 60.9237L132.774 54.8222L134.777 52.4545C134.868 52.4545 134.868 52.4545 134.868 52.4545C134.959 53.0009 134.959 53.6384 135.141 54.2759Z'
          fill='white'
        />
        <path
          d='M134.959 52.3634C134.959 52.3634 134.959 52.4547 134.959 52.5461H134.868L134.959 52.3634Z'
          fill='white'
        />
        <path
          d='M134.322 51.5439L134.231 51.6349L133.593 52.3634C133.502 52.3634 133.411 52.3634 133.411 52.3634L133.866 51.4528C134.049 51.5438 134.231 51.5439 134.322 51.5439Z'
          fill='white'
        />
        <path
          d='M133.866 51.5439L133.411 52.4545C133.229 52.4545 133.138 52.3634 132.956 52.3634L133.411 51.5439C133.593 51.4528 133.684 51.5439 133.866 51.5439Z'
          fill='white'
        />
        <path
          d='M133.684 52.4545L133.138 53.0009L133.411 52.3634C133.502 52.3634 133.593 52.3635 133.684 52.4545Z'
          fill='white'
        />
        <path
          d='M133.411 52.3634L133.138 53.0009L131.954 54.3669L132.956 52.3634C133.138 52.3634 133.32 52.3634 133.411 52.3634Z'
          fill='white'
        />
        <path
          d='M133.411 51.4528L132.956 52.2724C132.136 52.0902 131.317 51.9081 130.406 51.5439L131.043 50.8153C131.954 51.1795 132.774 51.3617 133.411 51.4528Z'
          fill='white'
        />
        <path
          d='M132.956 52.2724L131.954 54.2759L126.945 60.0131C126.035 59.6488 125.124 59.1024 124.304 58.4649L130.315 51.5439C131.317 51.9081 132.227 52.1813 132.956 52.2724Z'
          fill='white'
        />
        <path
          d='M132.956 61.1059L132.5 62.0166C132.409 62.0166 132.318 62.0166 132.318 62.0166C131.681 62.0166 130.952 61.9255 130.224 61.8344C129.951 61.8344 129.677 61.7433 129.404 61.6523L129.86 60.8326C130.042 60.9237 130.224 60.9237 130.406 60.9237C131.317 61.1969 132.227 61.197 132.956 61.1059Z'
          fill='white'
        />
        <path
          d='M132.5 62.1076L104.998 118.296L102.448 116.657L129.313 61.7433C129.586 61.8344 129.859 61.8344 130.133 61.9254C130.861 62.0165 131.59 62.1076 132.227 62.1076C132.409 62.1076 132.5 62.1076 132.5 62.1076Z'
          fill='white'
        />
        <path
          d='M131.954 48.4476L130.133 50.451C129.586 50.2689 129.131 49.9957 128.585 49.7225C127.219 48.9029 125.579 47.719 124.578 45.7156C124.395 45.2602 124.122 44.7138 124.031 44.1674C122.847 39.0677 126.854 35.9714 128.311 35.0607C128.493 35.6071 128.585 36.2446 128.767 36.6999C129.04 37.7017 129.222 38.5213 129.222 38.9766C129.222 39.6141 128.676 40.5247 128.129 41.5265C127.127 43.2567 125.853 45.4424 127.219 47.1726C128.038 48.1744 129.222 48.7207 130.679 48.7207C131.134 48.6297 131.499 48.5386 131.954 48.4476Z'
          fill='#FCE8D0'
        />
        <path
          d='M130.497 57.4632L128.949 60.6505C128.585 60.5595 128.311 60.4684 127.947 60.3773L130.497 57.4632Z'
          fill='#FCE8D0'
        />
        <path
          d='M129.586 51.2706L123.758 58.0096C123.029 57.3721 122.483 56.5525 122.028 55.6418C119.842 50.9974 123.029 47.8101 124.213 46.8083C125.124 48.3565 126.49 49.6314 128.311 50.6332C128.676 50.8153 129.131 51.0885 129.586 51.2706Z'
          fill='#FCE8D0'
        />
        <path
          d='M127.036 60.0131L126.399 60.7416C125.488 60.2862 124.578 59.8309 123.849 59.1934L124.487 58.4649C125.215 59.1934 126.126 59.6488 127.036 60.0131Z'
          fill='white'
        />
        <path
          d='M126.399 60.7416L86.4206 106.548L83.8707 104.909L123.758 59.1935C124.578 59.8309 125.488 60.3773 126.399 60.7416Z'
          fill='white'
        />
        <path
          d='M121.937 128.951L121.846 129.406C121.846 129.497 121.754 129.679 121.663 129.861L119.114 128.222L119.296 127.311L121.937 128.951Z'
          fill='white'
        />
        <path
          d='M119.023 128.222L121.572 129.861C121.117 130.681 119.933 132.411 118.931 133.686C118.84 131.683 118.749 129.315 118.931 128.677L119.023 128.222Z'
          fill='white'
        />
        <path
          d='M118.294 135.416C118.658 135.781 118.658 136.327 118.385 136.691C117.292 137.875 116.928 141.518 117.019 143.521C117.019 143.886 116.837 144.159 116.564 144.341C116.2 144.341 115.835 144.25 115.562 144.25L112.375 142.246C111.919 141.973 111.828 141.427 112.102 140.971C112.375 140.516 112.921 140.425 113.376 140.698L115.107 141.882C115.198 139.97 115.562 136.964 116.928 135.507C117.292 135.143 117.839 135.143 118.294 135.416Z'
          fill='#05D362'
        />
        <path
          d='M118.294 135.325C117.839 135.143 117.383 135.143 117.019 135.507C115.653 136.964 115.289 139.97 115.198 141.882L113.467 140.698C113.012 140.425 112.466 140.516 112.193 140.971C111.919 141.427 112.01 141.973 112.466 142.246L115.471 144.25L115.562 144.341C115.744 144.432 115.926 144.523 116.108 144.523C116.199 144.523 116.291 144.523 116.291 144.523L117.474 146.709C97.2576 157.09 79.1353 173.664 76.5854 176.032L20.8526 128.495L19.6687 127.493C32.5091 108.005 63.745 96.1665 66.6592 95.1648L75.0373 100.447L82.6869 105.273L80.8656 107.368C80.137 108.187 78.1336 112.65 77.8604 113.105C77.7693 113.287 77.8604 113.469 77.9514 113.651C78.0425 113.742 78.1336 113.833 78.3157 113.833C78.4068 113.833 78.4068 113.833 78.4978 113.833C79.4085 113.469 83.7797 111.466 84.5082 110.646L86.7849 108.005L101.538 117.294L100.263 119.935C99.8074 120.846 99.0789 124.853 98.8968 125.945C98.8057 125.854 98.8057 125.763 98.7147 125.763C98.3504 125.399 97.804 125.49 97.4397 125.854C96.0737 127.311 95.7094 130.317 95.6184 132.229L93.8881 131.045C93.5238 130.772 92.8864 130.863 92.6132 131.318C92.34 131.774 92.431 132.32 92.8864 132.593L95.9827 134.688C96.1648 134.779 96.3469 134.87 96.5291 134.87C96.7112 134.87 96.8023 134.87 96.9844 134.779C97.2576 134.597 97.4397 134.324 97.4397 133.959C97.3487 131.956 97.7129 128.313 98.8057 127.129C98.8968 127.038 98.9879 126.856 98.9879 126.765L99.0789 126.856C99.17 126.856 99.2611 126.947 99.2611 126.947C99.3521 126.947 99.4432 126.947 99.5342 126.856C100.263 126.219 103.997 123.213 104.543 122.212L105.636 120.026L118.476 128.131L118.294 128.951C118.021 130.043 118.294 134.87 118.385 135.416C118.112 135.143 118.203 135.234 118.294 135.325ZM105.18 136.418C105.363 136.327 105.545 136.054 105.363 135.781C105.271 135.598 104.998 135.507 104.725 135.598C102.722 136.509 100.627 137.693 98.3504 138.877C89.7901 143.521 79.9549 149.987 72.3964 158.001C72.2142 158.183 72.2142 158.456 72.3964 158.638C72.4874 158.729 72.5785 158.729 72.6696 158.729C72.7606 158.729 72.9428 158.729 73.0338 158.547C80.6834 150.442 90.7918 143.886 99.3521 139.241C101.447 138.239 103.359 137.238 105.18 136.418ZM102.904 134.324C103.086 134.232 103.268 133.959 103.086 133.686C102.995 133.504 102.722 133.413 102.448 133.504C100.263 134.597 97.8951 135.781 95.3452 137.238C86.967 141.882 77.405 148.166 70.1197 155.997C69.9376 156.18 69.9376 156.453 70.1197 156.635C70.2108 156.726 70.3018 156.726 70.484 156.726C70.575 156.726 70.7571 156.726 70.8482 156.544C78.2246 148.712 87.9688 142.337 96.3469 137.693C98.6236 136.509 100.9 135.325 102.904 134.324ZM96.0737 144.705C96.2559 144.614 96.3469 144.25 96.2559 144.068C96.1648 143.886 95.8916 143.794 95.6184 143.886C86.967 149.076 79.8638 154.54 74.4909 160.278C74.3088 160.46 74.3088 160.733 74.4909 160.915C74.582 161.006 74.673 161.006 74.7641 161.006C74.8552 161.006 75.0373 160.915 75.1284 160.824C80.5013 155.269 87.5135 149.805 96.0737 144.705ZM86.3296 124.306C86.5117 124.215 86.6938 123.942 86.5117 123.669C86.4206 123.487 86.1474 123.304 85.8742 123.487C84.3261 124.306 82.5958 125.126 80.8656 126.036C72.3964 130.59 62.1969 137.056 54.5473 145.252C54.3651 145.434 54.3651 145.707 54.5473 145.889C54.6383 145.98 54.7294 145.98 54.9115 145.98C55.0937 145.98 55.1847 145.98 55.2758 145.798C62.9254 137.693 73.1249 131.227 81.5941 126.674C83.2333 125.854 84.8725 125.035 86.3296 124.306ZM84.144 122.303C84.3261 122.212 84.5082 121.938 84.3261 121.665C84.235 121.483 83.9618 121.301 83.6886 121.483C82.1405 122.212 80.5013 123.031 78.8621 123.942C70.3018 128.495 60.0113 135.052 52.2706 143.248C52.0885 143.43 52.0885 143.703 52.2706 143.886C52.3617 143.977 52.4527 143.977 52.5438 143.977C52.6349 143.977 52.817 143.977 52.9081 143.794C60.6487 135.598 70.9393 129.042 79.4085 124.579C81.1388 123.76 82.6869 123.031 84.144 122.303ZM77.4961 132.32C77.6782 132.229 77.7693 131.956 77.6782 131.683C77.5872 131.5 77.314 131.409 77.0408 131.5C68.6626 136.509 61.7415 141.882 56.5507 147.437C56.3686 147.619 56.3686 147.892 56.5507 148.075C56.6418 148.166 56.7329 148.166 56.8239 148.166C56.915 148.166 57.0971 148.166 57.1882 147.984C62.379 142.611 69.209 137.329 77.4961 132.32ZM77.4961 114.562C77.8604 114.198 77.7693 113.651 77.405 113.287C77.0408 112.923 76.4944 112.923 76.1301 113.378C75.1284 114.471 74.582 116.566 74.3998 118.296C74.3088 118.842 74.3088 119.297 74.3088 119.753L72.5785 118.569C72.1232 118.296 71.5768 118.387 71.3036 118.842C71.0303 119.297 71.1214 119.844 71.5768 120.117L74.673 122.212C74.8552 122.303 75.0373 122.394 75.2194 122.394C75.4016 122.394 75.4926 122.394 75.6748 122.303C75.948 122.121 76.1301 121.847 76.1301 121.483C76.1301 121.21 76.1301 120.937 76.1301 120.663C76.1301 118.569 76.4944 115.655 77.4961 114.562ZM64.3825 111.284C64.5646 111.193 64.7467 110.919 64.5646 110.646C64.4735 110.464 64.2004 110.282 63.9272 110.464C55.2758 114.744 43.0729 121.665 34.4215 130.954C34.2394 131.136 34.2394 131.409 34.4215 131.591C34.5126 131.683 34.6037 131.683 34.6947 131.683C34.7858 131.683 34.9679 131.592 35.059 131.5C43.7103 122.485 55.8222 115.473 64.3825 111.284ZM62.2879 109.462C62.4701 109.371 62.6522 109.098 62.4701 108.825C62.379 108.643 62.1058 108.461 61.8326 108.643C53.1813 112.923 40.9783 119.844 32.327 129.133C32.1448 129.315 32.1448 129.588 32.327 129.77C32.418 129.861 32.5091 129.861 32.6002 129.861C32.6913 129.861 32.8734 129.861 32.9645 129.679C41.6158 120.572 53.7277 113.651 62.2879 109.462ZM56.0954 118.842C56.2775 118.751 56.3686 118.387 56.2775 118.205C56.1865 118.023 55.8222 117.932 55.6401 118.023C47.7173 122.758 41.2515 127.767 36.3339 132.958C36.1518 133.14 36.1518 133.413 36.3339 133.595C36.425 133.686 36.5161 133.686 36.6071 133.686C36.6982 133.686 36.8803 133.686 36.9714 133.595C41.889 128.495 48.2637 123.578 56.0954 118.842Z'
          fill='white'
        />
        <path
          d='M116.473 144.341C116.382 144.341 116.382 144.432 116.291 144.432C116.199 144.432 116.199 144.432 116.108 144.432C115.926 144.432 115.744 144.341 115.562 144.25L115.471 144.159C115.744 144.25 116.108 144.341 116.473 144.341Z'
          fill='#05D362'
        />
        <path
          d='M104.998 118.296L104.634 119.115L102.084 117.476L102.539 116.657L104.998 118.296Z'
          fill='white'
        />
        <path
          d='M104.634 119.115L103.541 121.392C103.268 121.938 101.356 123.578 99.8074 124.944C100.172 122.94 100.627 120.572 100.9 120.117L102.175 117.567L104.634 119.115Z'
          fill='white'
        />
        <path
          d='M98.7145 125.763C98.8056 125.945 98.8967 126.219 98.8056 126.401C98.7145 126.31 98.6235 126.128 98.7145 126.036C98.6235 125.945 98.6235 125.854 98.7145 125.763Z'
          fill='#05D362'
        />
        <path
          d='M98.7147 125.763C98.7147 125.854 98.7147 125.945 98.6236 126.036C98.6236 126.219 98.6236 126.31 98.7147 126.401C98.7147 126.583 98.6236 126.674 98.5326 126.765C97.4398 127.949 97.0755 131.592 97.1666 133.595C97.1666 133.959 96.9844 134.232 96.7112 134.415C96.6202 134.506 96.438 134.506 96.2559 134.506C96.0738 134.506 95.8916 134.415 95.7095 134.324L92.6132 132.229C92.249 131.956 92.0668 131.409 92.34 130.954C92.6132 130.499 93.1596 130.408 93.615 130.681L95.3452 131.865C95.4363 129.952 95.8006 126.947 97.1666 125.49C97.5308 125.126 98.0772 125.126 98.4415 125.399C98.6236 125.581 98.6236 125.672 98.7147 125.763Z'
          fill='#05D362'
        />
        <path
          d='M86.4207 106.548L85.7833 107.277L83.3245 105.637L83.8709 105L86.4207 106.548Z'
          fill='white'
        />
        <path
          d='M85.7833 107.277L83.5976 109.827C83.2334 110.282 80.9567 111.375 79.0443 112.285C79.8639 110.464 80.9567 108.37 81.4121 107.914L83.3245 105.729L85.7833 107.277Z'
          fill='white'
        />
        <path
          d='M77.405 113.287C77.7693 113.651 77.7693 114.198 77.4961 114.562C76.4943 115.655 76.13 118.478 76.13 120.572C75.5836 119.844 75.0372 119.024 74.4908 118.296C74.673 116.566 75.2194 114.471 76.2211 113.378C76.4943 113.014 77.0407 113.014 77.405 113.287Z'
          fill='#05D362'
        />
        <path
          d='M76.0391 121.392C76.0391 121.756 75.8569 122.03 75.5837 122.212C75.4927 122.303 75.3105 122.303 75.1284 122.303C74.9463 122.303 74.7641 122.212 74.582 122.121L71.4857 120.026C71.0304 119.753 70.9393 119.206 71.2125 118.751C71.4857 118.296 72.0321 118.205 72.4874 118.478L74.2177 119.662C74.2177 119.206 74.3088 118.751 74.3088 118.205C74.8552 119.024 75.4016 119.753 75.948 120.481C76.039 120.846 76.0391 121.119 76.0391 121.392Z'
          fill='#05D362'
        />
        <path
          d='M18.8492 127.949L75.4927 176.214C68.2074 177.125 24.04 183.408 0.817962 201.713C0.726896 201.713 0.726898 201.804 0.635832 201.804C-0.548036 202.715 -1.64084 203.716 -2.73364 204.718V193.426C-2.73364 193.426 -2.73364 193.426 -2.73364 193.517C-2.64258 193.608 -2.55151 193.699 -2.36937 193.699C-2.27831 193.699 -2.18724 193.699 -2.09617 193.608C-1.91404 193.426 18.667 178.673 55.9134 169.293C56.1866 169.202 56.2776 169.02 56.2776 168.747C56.1865 168.474 56.0044 168.382 55.7312 168.382C18.3028 177.762 -2.36937 192.697 -2.5515 192.788C-2.64257 192.788 -2.64258 192.879 -2.64258 192.971V189.874C-2.46044 189.692 17.6653 175.577 53.2724 166.743C53.5456 166.652 53.6367 166.47 53.6367 166.197C53.5456 165.924 53.2724 165.833 53.0903 165.833C20.3973 173.938 0.635826 186.596 -2.64258 188.781V185.776C0.909027 183.5 19.942 171.661 50.5404 164.193C50.8136 164.102 50.9047 163.92 50.9047 163.647C50.8136 163.374 50.6315 163.283 50.3583 163.283C20.7616 170.477 2.00183 181.678 -2.64258 184.683V173.664C3.27676 170.295 19.4866 161.826 42.3444 156.544C42.6176 156.453 42.7087 156.271 42.7087 155.997C42.6176 155.724 42.4355 155.633 42.1623 155.633C19.7598 160.824 3.7321 169.02 -2.64258 172.572V169.657C3.64103 166.197 18.8492 158.729 39.6124 153.994C39.8856 153.903 39.9767 153.721 39.9767 153.448C39.8856 153.174 39.7035 153.083 39.4303 153.083C19.0313 157.728 3.91423 165.013 -2.64258 168.565V165.65C3.82316 162.281 18.1206 155.542 36.8804 151.444C37.1536 151.353 37.2447 151.171 37.2447 150.898C37.1536 150.624 36.9715 150.533 36.6983 150.533C18.2117 154.631 4.09636 161.188 -2.64258 164.649V153.994C3.82316 151.08 15.2065 146.526 28.6844 143.886C28.9576 143.794 29.1397 143.612 29.0487 143.339C28.9576 143.066 28.7755 142.884 28.5023 142.975C15.2065 145.616 3.91423 150.078 -2.64258 152.992V150.169C3.64103 147.437 14.0226 143.521 25.9524 141.336C26.2256 141.336 26.3167 141.062 26.3167 140.789C26.2256 140.516 26.0435 140.425 25.7703 140.425C14.0226 142.611 3.7321 146.435 -2.64258 149.167V146.344C3.4589 143.886 12.8388 140.607 23.2204 138.786C23.4936 138.786 23.5847 138.513 23.5847 138.239C23.5847 137.966 23.3115 137.784 23.0383 137.875C12.8388 139.696 3.4589 142.884 -2.64258 145.343V142.611C3.09463 140.425 11.5638 137.693 20.4884 136.236C20.7616 136.236 20.9437 135.963 20.8526 135.689C20.8526 135.416 20.5795 135.234 20.3062 135.325C11.4728 136.691 3.1857 139.423 -2.64258 141.609V131.591C-1.00338 131.227 7.73904 128.677 18.8492 127.949Z'
          fill='white'
        />
        <path
          d='M68.6626 178.127C63.0164 179.675 54.9115 182.134 46.2602 185.412C25.4969 193.153 11.6548 201.44 5.18906 210L1.54639 202.259C20.5793 187.415 53.5455 180.585 68.6626 178.127Z'
          fill='#D1E7F0'
        />
        <path
          d='M19.5776 127.402L20.7615 128.404L19.5776 127.402Z'
          fill='#781610'
        />
        <path
          d='M0.817985 201.713C1.09119 201.622 1.27332 201.713 1.45545 201.895L1.63759 202.259C20.5795 187.507 53.6367 180.677 68.7538 178.218C72.0322 177.307 74.3999 176.67 75.6749 176.396L75.5838 176.305C67.8431 177.307 19.3045 184.228 -2.55148 204.718V193.426C-2.64255 193.335 -2.64255 193.153 -2.55148 192.971V189.874C-2.64255 189.874 -2.73362 189.965 -2.82469 189.965C-3.00682 189.965 -3.09789 189.874 -3.18895 189.783C-3.37109 189.601 -3.28002 189.328 -3.09789 189.146C-3.09789 189.146 -2.91576 189.055 -2.64256 188.781V185.776C-3.00682 186.049 -3.18895 186.141 -3.28002 186.141C-3.37109 186.232 -3.46216 186.232 -3.55322 186.232V205.72C-3.55322 205.902 -3.46215 206.084 -3.28002 206.175C-3.18895 206.175 -3.18896 206.175 -3.09789 206.175C-3.00682 206.175 -2.82469 206.175 -2.73362 206.084C-1.54975 204.991 -0.365885 203.899 0.90905 202.806L0.635854 202.259C0.45372 202.077 0.544784 201.804 0.817985 201.713Z'
          fill='#781610'
        />
        <path
          d='M-2.73362 131.774C-1.00335 131.227 7.73906 128.677 18.8492 127.949L18.6671 127.858C18.4849 127.676 18.4849 127.494 18.576 127.22C18.576 127.129 18.6671 127.129 18.6671 127.038C6.28199 127.858 -3.28002 130.954 -3.37108 130.954C-3.55322 131.045 -3.64429 131.227 -3.64429 131.409V142.155C-3.37109 142.064 -3.00682 141.882 -2.73362 141.791V131.774Z'
          fill='#781610'
        />
        <path
          d='M87.2402 107.003L86.6028 107.732L101.356 117.021L101.72 116.201L87.2402 107.003Z'
          fill='#781610'
        />
        <path
          d='M123.849 144.614C123.485 144.614 123.121 144.614 122.756 144.614C122.392 144.614 121.937 144.614 121.573 144.614C99.7165 154.722 79.3175 173.391 76.5855 175.941L20.8527 128.404L76.6766 175.941C77.223 175.577 78.7711 174.575 81.0478 173.209C88.5153 166.561 105.909 152.446 123.849 144.614Z'
          fill='#781610'
        />
        <path
          d='M105.818 118.751L105.454 119.571L118.203 127.676L118.385 126.765L105.818 118.751Z'
          fill='#781610'
        />
        <path
          d='M18.8492 127.949L75.4017 176.214L18.8492 127.949Z'
          fill='#781610'
        />
        <path
          d='M19.3045 127.129L19.5777 127.402C32.4181 107.914 63.654 96.1665 66.5681 95.0737L74.9462 100.356C75.1284 100.082 75.3105 99.8092 75.4016 99.6271L66.8413 94.2541C66.7502 94.1631 66.5681 94.1631 66.4771 94.2541C66.1128 94.3452 32.2359 106.457 18.7581 127.129C18.8491 127.129 18.9402 127.129 18.9402 127.129C19.0313 127.038 19.2134 127.038 19.3045 127.129Z'
          fill='#781610'
        />
        <path
          d='M136.69 139.332C135.506 139.605 134.322 139.879 133.138 140.243C132.865 140.698 132.592 141.062 132.227 141.427C134.14 140.789 136.052 140.334 137.965 139.97C138.147 139.97 138.329 139.788 138.329 139.605C138.329 139.423 138.238 139.241 138.147 139.15L134.504 136.873C134.413 137.147 134.322 137.511 134.231 137.784L136.69 139.332Z'
          fill='#781610'
        />
        <path
          d='M129.222 141.518C129.313 141.518 129.404 141.518 129.495 141.518L130.497 141.973C131.043 141.791 131.59 141.609 132.136 141.427C132.5 141.062 132.774 140.607 133.047 140.243C131.772 140.607 130.497 141.063 129.222 141.518Z'
          fill='#781610'
        />
        <path
          d='M82.5048 105.182L83.1423 104.454L75.4016 99.536C75.2195 99.8092 75.0374 100.082 74.9463 100.265L82.5048 105.182Z'
          fill='#781610'
        />
        <path
          d='M128.949 141.7C129.04 141.609 129.04 141.518 129.222 141.518C126.672 142.428 124.122 143.521 121.573 144.705C121.937 144.705 122.392 144.705 122.756 144.705C123.121 144.705 123.485 144.705 123.849 144.705C125.671 143.886 127.492 143.157 129.313 142.52L129.131 142.428C128.858 142.246 128.767 141.973 128.949 141.7Z'
          fill='#781610'
        />
        <path
          d='M122.665 129.588C122.665 129.77 122.483 130.043 122.301 130.317L134.14 137.784C134.231 137.511 134.322 137.147 134.413 136.873L122.665 129.497V129.588Z'
          fill='#781610'
        />
        <path
          d='M18.667 127.858L18.8491 127.949L75.4927 176.214L75.5837 176.305C75.948 176.214 76.2212 176.123 76.4033 176.123C76.4944 176.123 76.4944 176.032 76.5855 175.941L20.7615 128.404L19.5777 127.402L19.3045 127.129C19.2134 127.038 19.1223 127.038 18.9402 127.038C18.8491 127.038 18.7581 127.038 18.7581 127.038C18.7581 127.129 18.667 127.129 18.667 127.22C18.4849 127.494 18.4849 127.676 18.667 127.858Z'
          fill='#781610'
        />
        <path
          d='M139.148 147.164C136.872 147.528 134.595 148.075 132.227 148.712C132.318 148.712 132.318 148.712 132.409 148.712L134.231 149.167C136.507 148.621 138.693 148.166 140.788 147.801C140.97 147.801 141.152 147.619 141.152 147.437C141.152 147.255 141.061 147.073 140.879 146.982L131.226 142.337C130.952 142.52 130.679 142.793 130.406 142.975L139.148 147.164Z'
          fill='#781610'
        />
        <path
          d='M129.313 142.429L130.406 142.975C130.679 142.793 130.952 142.611 131.226 142.337L130.497 141.973C130.133 142.155 129.677 142.246 129.313 142.429Z'
          fill='#781610'
        />
        <path
          d='M79.3175 174.666C80.7746 173.938 82.5959 173.027 84.7815 171.934C95.5274 165.468 115.289 154.449 132.318 149.623H132.227C131.954 149.532 131.863 149.35 131.863 149.076C131.863 148.894 132.045 148.803 132.136 148.712C113.012 154.085 90.4276 167.29 80.8656 173.209C80.3192 173.755 79.7728 174.211 79.3175 174.666Z'
          fill='#781610'
        />
        <path
          d='M68.6626 178.127C63.0165 179.675 54.9115 182.134 46.2602 185.412C25.497 193.153 11.6548 201.44 5.18908 210L1.54641 202.168C1.27321 202.35 1.09107 202.533 0.817871 202.715L4.73374 211.002C4.82481 211.184 4.91587 211.275 5.09801 211.275C5.28014 211.275 5.37121 211.184 5.46227 211.093C11.4727 202.533 25.6791 193.881 46.5334 186.141C51.1778 184.41 55.6401 182.953 59.647 181.678C63.1986 180.312 66.9323 178.946 70.8482 177.671C70.2107 177.945 69.4822 178.036 68.6626 178.127Z'
          fill='#781610'
        />
        <path
          d='M1.3644 201.895C1.27334 201.713 1.00014 201.531 0.726939 201.713C0.544806 201.804 0.362668 202.077 0.544802 202.35L0.818005 202.897C1.09121 202.715 1.27334 202.533 1.54654 202.35L1.3644 201.895Z'
          fill='#781610'
        />
        <path
          d='M75.5837 176.305C74.3998 176.579 71.941 177.216 68.6626 178.127C69.4822 178.036 70.2107 177.853 70.8482 177.762C72.3963 177.307 73.9445 176.852 75.5837 176.305Z'
          fill='#781610'
        />
        <path
          d='M128.949 141.7C128.858 141.882 128.949 142.155 129.131 142.337L129.313 142.428C129.677 142.246 130.133 142.155 130.497 141.973L129.495 141.518C129.404 141.427 129.313 141.427 129.222 141.518H129.131C129.04 141.518 128.949 141.609 128.949 141.7Z'
          fill='#781610'
        />
        <path
          d='M79.3175 174.666C79.7728 174.211 80.3192 173.755 80.9567 173.209C78.68 174.575 77.2229 175.577 76.5854 175.941C77.0408 175.85 77.9515 175.304 79.3175 174.666Z'
          fill='#781610'
        />
        <path
          d='M76.4033 176.123C76.2212 176.123 75.948 176.214 75.5837 176.305C75.8569 176.305 76.1301 176.214 76.4033 176.123Z'
          fill='#781610'
        />
        <path
          d='M9.74256 212.459C9.56042 212.641 9.56042 212.914 9.74256 213.096C9.83362 213.187 9.92469 213.187 10.0158 213.187C10.1068 213.187 10.289 213.096 10.38 213.005C10.5622 212.732 32.8735 189.419 76.4945 176.943C75.4928 177.216 68.7538 178.855 59.6471 181.678C26.772 194.61 9.92469 212.277 9.74256 212.459Z'
          fill='#781610'
        />
        <path
          d='M137.236 150.807C124.031 153.265 98.1684 165.377 84.7816 171.934C79.955 174.848 76.8588 176.852 76.7677 176.943C76.7677 176.943 76.7677 176.943 76.6766 176.943C77.132 176.67 123.576 152.992 139.604 151.353C139.786 151.353 139.968 151.171 139.968 150.898C139.968 150.624 139.877 150.442 139.604 150.442L134.049 149.167C133.411 149.35 132.774 149.532 132.136 149.623L137.236 150.807Z'
          fill='#781610'
        />
        <path
          d='M132.227 148.712C131.954 148.803 131.863 148.894 131.863 149.076C131.772 149.35 131.954 149.532 132.227 149.623H132.318C132.956 149.441 133.593 149.258 134.231 149.167L132.409 148.712C132.318 148.712 132.318 148.712 132.227 148.712Z'
          fill='#781610'
        />
        <path
          d='M70.8483 177.762C66.9324 179.037 63.1987 180.312 59.6471 181.769C68.7538 178.946 75.5838 177.216 76.4944 177.034C76.4944 177.034 76.4944 177.034 76.5855 177.034C76.4034 177.034 74.3088 177.307 70.8483 177.762Z'
          fill='#781610'
        />
        <path
          d='M76.8588 176.852C76.8588 176.943 76.8588 176.943 76.8588 176.852C76.7677 176.943 76.7677 176.943 76.8588 176.852C76.8588 176.852 79.955 174.848 84.7816 171.934C82.596 173.027 80.6836 173.938 79.3176 174.666C77.7694 176.032 76.8588 176.852 76.8588 176.852Z'
          fill='#781610'
        />
        <path
          d='M76.4945 177.034C76.4035 177.034 76.3124 177.034 76.2213 176.943L75.5839 176.396C73.9447 176.852 72.3965 177.307 70.8484 177.853C74.3089 177.307 76.4035 177.034 76.4945 177.034C76.5856 177.034 76.5856 177.034 76.4945 177.034Z'
          fill='#781610'
        />
        <path
          d='M76.8587 176.214C77.0408 176.305 77.0408 176.487 77.0408 176.67C77.0408 176.761 76.9497 176.852 76.8587 176.852C76.9497 176.761 77.7693 175.941 79.3175 174.575C77.9515 175.213 77.0408 175.759 76.5854 175.941L76.8587 176.214Z'
          fill='#781610'
        />
        <path
          d='M76.5854 177.034C76.6768 176.943 76.6768 177.034 76.5854 177.034C76.6768 177.034 76.6768 177.034 76.6768 177.034C76.6768 177.034 76.6768 177.034 76.7681 177.034C76.7681 176.943 76.6768 177.034 76.5854 177.034Z'
          fill='#781610'
        />
        <path
          d='M76.8588 176.214L76.6767 176.032C76.5856 176.032 76.4945 176.123 76.4945 176.123C76.2213 176.214 75.9481 176.305 75.6749 176.396L76.3124 176.943C76.4035 177.034 76.4945 177.034 76.5856 177.034H76.6767C76.7677 177.034 76.7677 177.034 76.8588 176.943C76.9499 176.852 76.9499 176.852 77.0409 176.761C77.0409 176.487 76.9499 176.305 76.8588 176.214Z'
          fill='#781610'
        />
        <path
          d='M155.996 28.1397L155.358 28.8682C156.542 29.6878 157.544 30.6895 158.545 31.6913C158.819 31.5091 159.001 31.327 159.274 31.1449C158.363 30.0521 157.271 29.0503 155.996 28.1397Z'
          fill='#781610'
        />
        <path
          d='M129.04 34.1501C129.131 34.3322 129.04 34.6054 128.858 34.7875C128.858 34.7875 128.585 34.8786 128.311 35.0607C128.494 35.6071 128.585 36.2446 128.767 36.6999C129.04 37.7017 129.222 38.5213 129.222 38.8855C129.222 39.523 128.676 40.4337 128.129 41.4354C127.128 43.1657 125.853 45.4423 127.219 47.0816C128.038 48.0833 129.222 48.6297 130.588 48.6297C131.043 48.6297 131.408 48.5386 131.863 48.4476L133.138 46.9905C132.318 47.4458 131.408 47.628 130.588 47.719C129.404 47.719 128.494 47.2637 127.856 46.5351C126.945 45.3513 127.947 43.621 128.858 41.8907C129.495 40.7979 130.042 39.7962 130.042 38.9766C130.042 38.4302 129.86 37.6106 129.495 36.5178C128.767 33.6947 127.583 29.5057 129.769 26.7737C131.499 24.5881 136.416 23.3131 142.063 23.8595L142.245 22.9489C136.325 22.3114 131.135 23.5863 129.04 26.2273C127.219 28.5039 127.401 31.5091 127.947 34.1501C128.129 34.059 128.22 33.9679 128.22 33.9679C128.676 33.8769 128.949 33.9679 129.04 34.1501Z'
          fill='#781610'
        />
        <path
          d='M165.74 41.7997C167.197 44.3496 168.199 46.1709 169.292 46.7173C171.75 48.0833 179.764 51.6349 181.312 52.2724C181.586 52.0902 181.768 51.817 182.041 51.6349L181.95 51.5439C181.859 51.5439 172.479 47.3548 169.747 45.8977C168.927 45.4424 167.834 43.53 166.56 41.3444C164.92 38.4302 162.644 34.5143 159.365 31.0538C159.092 31.2359 158.91 31.4181 158.637 31.6002C161.733 34.9697 164.01 38.7945 165.74 41.7997Z'
          fill='#781610'
        />
        <path
          d='M138.511 39.8873C138.966 36.791 138.875 33.8769 138.875 33.6947C138.875 33.4215 138.602 33.2394 138.42 33.2394C138.147 33.2394 137.965 33.4215 137.965 33.6947C137.965 33.7858 138.238 39.2498 136.781 42.8925L138.147 41.3444L138.511 39.8873Z'
          fill='#781610'
        />
        <path
          d='M151.26 26.3184L151.898 25.5898C151.716 25.4987 151.625 25.4988 151.442 25.4077L151.078 26.2273C151.078 26.3183 151.169 26.3184 151.26 26.3184Z'
          fill='#781610'
        />
        <path
          d='M124.669 45.8066C124.851 45.9888 124.76 46.262 124.578 46.4441C124.578 46.4441 124.396 46.5352 124.213 46.7173C125.124 48.2655 126.49 49.5404 128.311 50.5421C128.767 50.8153 129.222 50.9974 129.677 51.1796L130.315 50.4511C129.768 50.2689 129.313 49.9957 128.767 49.7225C127.036 48.8119 124.942 47.0816 124.213 44.1674C123.03 39.0677 127.036 35.9714 128.494 35.0608C128.402 34.7876 128.311 34.4233 128.311 34.1501C127.036 34.9697 121.937 38.5213 123.394 44.4406C123.485 44.987 123.667 45.4424 123.94 45.8977C124.122 45.7156 124.213 45.7156 124.213 45.6245C124.213 45.5334 124.487 45.6245 124.669 45.8066Z'
          fill='#781610'
        />
        <path
          d='M128.858 34.7875C129.04 34.6964 129.131 34.4232 129.04 34.15C128.949 33.9679 128.676 33.8769 128.403 33.9679C128.403 33.9679 128.312 34.059 128.129 34.15C128.22 34.5143 128.312 34.7875 128.312 35.0607C128.585 34.8786 128.767 34.7875 128.858 34.7875Z'
          fill='#781610'
        />
        <path
          d='M121.937 55.5508C119.842 50.9064 122.938 47.719 124.122 46.7173C123.94 46.4441 123.849 46.1709 123.667 45.8977C122.574 46.8084 118.658 50.5421 121.117 55.915C121.572 56.9168 122.301 57.8274 123.121 58.556L123.758 57.8274C123.03 57.281 122.392 56.4614 121.937 55.5508Z'
          fill='#781610'
        />
        <path
          d='M127.947 60.3773L127.31 61.1059C127.674 61.288 128.129 61.379 128.494 61.4701L128.858 60.6505C128.585 60.6505 128.22 60.4684 127.947 60.3773Z'
          fill='#781610'
        />
        <path
          d='M124.487 46.4441C124.669 46.2619 124.76 45.9888 124.578 45.8066C124.396 45.6245 124.122 45.5334 123.94 45.7155C123.94 45.7155 123.849 45.8066 123.667 45.9887C123.758 46.2619 123.94 46.5352 124.122 46.8084C124.305 46.5352 124.487 46.4441 124.487 46.4441Z'
          fill='#781610'
        />
        <path
          d='M149.53 67.6626C143.611 66.843 140.059 64.111 138.238 62.1986L137.964 63.2915C139.968 65.2949 143.611 67.7537 149.439 68.5733C153.992 69.2108 156.633 68.8465 158.637 68.5733C158.454 68.3001 158.363 68.0269 158.181 67.7537C156.269 67.9359 153.81 68.209 149.53 67.6626Z'
          fill='#781610'
        />
        <path
          d='M165.284 67.6626C162.826 66.843 161.369 67.1163 159.365 67.4805C159.001 67.5716 158.637 67.5716 158.272 67.6626C158.454 67.9358 158.546 68.2091 158.728 68.4823C159.001 68.3912 159.274 68.3912 159.547 68.3001C161.46 67.9358 162.735 67.7537 165.011 68.4823C169.382 69.9393 173.389 72.1249 174.118 72.4892C174.118 72.1249 174.118 71.7607 174.027 71.3964C172.661 70.7589 169.018 68.9376 165.284 67.6626Z'
          fill='#781610'
        />
        <path
          d='M216.555 64.3842L184.955 49.9046C184.773 49.8135 184.682 49.8135 184.5 49.9046C183.589 50.451 182.769 51.0885 181.95 51.7259C182.132 51.817 182.132 52.0902 182.041 52.2724C181.95 52.4545 181.768 52.5456 181.586 52.5456C181.494 52.5456 181.494 52.5456 181.403 52.5456C181.403 52.5456 181.312 52.4545 181.13 52.4545C174.664 58.1917 173.663 66.1145 173.845 71.5785C174.209 71.7607 174.482 71.9428 174.482 71.9428C174.664 72.0338 174.755 72.3071 174.664 72.5803C174.573 72.7624 174.391 72.8534 174.3 72.8534C174.209 72.8534 174.118 72.8535 174.118 72.7624C174.118 72.7624 174.027 72.7624 174.027 72.6713C174.209 75.8586 174.847 78.0442 174.847 78.1353C174.847 78.2264 174.938 78.4085 175.12 78.4085L215.462 96.804C215.553 96.804 215.553 96.804 215.644 96.804C215.736 96.804 215.827 96.804 215.918 96.7129C216.009 96.6219 216.1 96.5308 216.1 96.3487L216.737 64.8396C216.828 64.5664 216.737 64.4753 216.555 64.3842ZM215.28 95.5291L187.869 83.0529V83.144C187.96 83.4172 187.778 83.5993 187.596 83.6904H187.505C187.323 83.6904 187.141 83.5993 187.05 83.3261C187.05 83.3261 186.958 83.053 186.867 82.5065L175.757 77.4068C175.211 75.4033 171.568 59.1934 184.864 50.7242L196.156 55.915C196.338 55.824 196.52 55.6418 196.703 55.5508C196.885 55.4597 197.158 55.4597 197.34 55.7329C197.431 55.915 197.431 56.1882 197.158 56.3704L215.918 65.0217L215.28 95.5291Z'
          fill='#781610'
        />
        <path
          d='M181.586 52.4545C181.677 52.4545 181.677 52.4545 181.768 52.4545C181.95 52.4545 182.132 52.3634 182.223 52.1813C182.314 51.9991 182.223 51.817 182.132 51.6349C181.859 51.817 181.677 52.0902 181.403 52.2724C181.403 52.3634 181.495 52.4545 181.586 52.4545Z'
          fill='#781610'
        />
        <path
          d='M174.391 72.6713C174.573 72.6713 174.664 72.5803 174.755 72.3981C174.846 72.216 174.755 71.9428 174.573 71.7607C174.573 71.7607 174.3 71.6696 173.936 71.3964C173.936 71.7607 173.936 72.125 174.027 72.4892C174.118 72.4892 174.118 72.5803 174.118 72.5803C174.3 72.5803 174.3 72.6713 174.391 72.6713Z'
          fill='#781610'
        />
        <path
          d='M197.158 56.4614L196.156 56.0061C183.68 64.2021 186.048 78.9549 186.867 82.5976L187.96 83.0529C187.596 81.778 183.316 65.0217 197.158 56.4614Z'
          fill='#781610'
        />
        <path
          d='M187.049 83.4172C187.141 83.5993 187.323 83.7814 187.505 83.7814H187.596C187.869 83.6904 187.96 83.4172 187.869 83.2351C187.869 83.2351 187.869 83.235 187.869 83.144L186.776 82.6886C186.958 83.0529 187.049 83.3261 187.049 83.4172Z'
          fill='#781610'
        />
        <path
          d='M197.158 56.4614C197.34 56.3703 197.431 56.0061 197.34 55.8239C197.249 55.6418 196.885 55.5508 196.703 55.6418C196.521 55.7329 196.338 55.915 196.156 56.0061L197.158 56.4614Z'
          fill='#781610'
        />
        <path
          d='M134.049 61.015L134.14 60.9237L134.049 61.015Z'
          fill='#781610'
        />
        <path
          d='M138.238 41.2533L138.602 40.889L138.875 40.2515L142.7 23.8595C142.518 23.8595 142.427 23.8595 142.245 23.8595L138.511 39.8873C138.42 40.3426 138.329 40.798 138.238 41.2533Z'
          fill='#781610'
        />
        <path
          d='M133.593 62.0165L133.229 62.745L118.385 126.765L118.749 127.038L133.775 62.0165C133.775 62.0165 133.684 62.0165 133.593 62.0165Z'
          fill='#781610'
        />
        <path
          d='M137.6 62.9272L122.301 129.224L122.665 129.497L137.965 63.2914C137.873 63.1093 137.782 63.0183 137.6 62.9272Z'
          fill='#781610'
        />
        <path
          d='M146.616 6.64793C146.889 5.64619 147.891 4.91765 148.984 5.19085C149.985 5.46405 150.714 6.46579 150.441 7.55859L146.707 23.7685C146.798 23.7685 146.889 23.7685 146.98 23.8595L147.344 23.0399L150.896 7.64967C151.169 6.37473 150.35 5.09978 149.075 4.73552C148.437 4.55338 147.8 4.73551 147.253 5.00871C146.707 5.37297 146.343 5.91938 146.161 6.46578L142.336 22.8578C142.518 22.8578 142.609 22.8578 142.791 22.9489L146.616 6.64793Z'
          fill='#781610'
        />
        <path
          d='M139.057 56.6436L137.873 61.7433C137.964 61.8344 138.147 62.0165 138.238 62.1076L139.604 56.3704C139.422 56.5525 139.239 56.6436 139.057 56.6436Z'
          fill='#781610'
        />
        <path
          d='M118.567 134.961C118.567 134.961 118.294 129.679 118.476 128.586L118.658 127.949L118.294 127.676L118.112 128.495C117.839 129.588 118.112 134.415 118.203 134.961C118.203 135.143 118.385 135.325 118.567 135.325H118.658C118.84 135.325 118.932 135.234 119.023 135.143C119.478 134.506 121.664 131.774 122.483 130.226L122.119 129.952C121.117 131.592 118.567 134.961 118.567 134.961Z'
          fill='#781610'
        />
        <path
          d='M122.21 129.497C122.21 129.679 122.119 129.861 121.937 130.043L122.301 130.317C122.483 130.043 122.574 129.77 122.665 129.588V129.497L122.301 129.224L122.21 129.497Z'
          fill='#781610'
        />
        <path
          d='M118.385 126.765L118.203 127.676L118.658 127.949L118.841 126.947L118.385 126.765Z'
          fill='#781610'
        />
        <path
          d='M146.525 24.5881L146.889 23.7685C146.798 23.7685 146.707 23.7685 146.616 23.6774L146.525 24.5881Z'
          fill='#781610'
        />
        <path
          d='M138.238 41.2533C138.329 40.798 138.42 40.3426 138.511 39.8873L138.238 41.2533Z'
          fill='#781610'
        />
        <path
          d='M142.7 23.8595L142.882 22.9489C142.7 22.9489 142.609 22.9489 142.427 22.8578L142.245 23.7685C142.336 23.8595 142.518 23.8595 142.7 23.8595Z'
          fill='#781610'
        />
        <path
          d='M134.049 61.0148L133.593 62.0165C133.684 62.0165 133.776 62.0165 133.867 62.0165L134.049 61.0148Z'
          fill='#781610'
        />
        <path
          d='M137.6 62.9272C137.691 63.0183 137.873 63.2004 137.964 63.2914L138.238 62.1986C138.147 62.0165 137.964 61.9254 137.873 61.8344L137.6 62.9272Z'
          fill='#781610'
        />
        <path
          d='M147.071 6.73899C147.162 6.37473 147.435 6.01046 147.709 5.82833C147.982 5.64619 148.255 5.64618 148.528 5.64618C148.619 5.64618 148.71 5.64618 148.892 5.64618C149.712 5.82831 150.167 6.64792 149.985 7.46752L146.252 23.6774C146.434 23.6774 146.525 23.7685 146.707 23.7685L150.441 7.55859C150.714 6.55685 149.985 5.46405 148.984 5.19085C147.982 4.91765 146.889 5.64619 146.616 6.64792L142.882 22.9489C143.064 22.9489 143.155 22.9489 143.337 23.0399L147.071 6.73899Z'
          fill='#781610'
        />
        <path
          d='M118.931 133.686C118.84 131.683 118.749 129.315 118.931 128.677L119.023 128.131L118.658 127.858L118.476 128.495C118.203 129.497 118.567 134.87 118.567 134.87C118.567 134.87 121.117 131.592 122.028 129.952L121.663 129.679C121.117 130.681 119.933 132.32 118.931 133.686Z'
          fill='#781610'
        />
        <path
          d='M133.866 61.9254L118.84 126.947L119.205 127.22L134.322 61.8344C134.231 61.9254 134.049 61.9254 133.866 61.9254Z'
          fill='#781610'
        />
        <path
          d='M139.786 38.4302L143.155 23.9506C142.973 23.9506 142.882 23.8595 142.7 23.8595L138.875 40.2515L139.786 38.4302Z'
          fill='#781610'
        />
        <path
          d='M146.434 24.8613L146.525 24.6791C146.343 24.6791 146.252 24.588 146.069 24.588L145.614 26.6826L146.434 24.8613Z'
          fill='#781610'
        />
        <path
          d='M121.937 128.951L122.301 129.224L137.6 62.9272C137.509 62.7451 137.327 62.654 137.236 62.4719L121.937 128.951Z'
          fill='#781610'
        />
        <path
          d='M134.049 61.0148C134.231 61.0148 134.413 60.9237 134.504 60.9237L134.868 59.1934L134.049 61.0148Z'
          fill='#781610'
        />
        <path
          d='M137.509 61.3791C137.6 61.5612 137.782 61.6523 137.873 61.8344L139.057 56.7346C138.875 56.8257 138.693 56.8257 138.602 56.8257L137.509 61.3791Z'
          fill='#781610'
        />
        <path
          d='M119.205 127.22L118.841 126.947L118.658 127.949L119.023 128.222L119.205 127.22Z'
          fill='#781610'
        />
        <path
          d='M121.846 129.315C121.846 129.406 121.755 129.588 121.664 129.77L122.028 130.043C122.119 129.77 122.21 129.588 122.301 129.497L122.392 129.224L122.028 128.951L121.846 129.315Z'
          fill='#781610'
        />
        <path
          d='M143.337 23.0399C143.155 23.0399 143.064 23.0399 142.882 22.9489L142.7 23.8595C142.882 23.8595 142.973 23.8595 143.155 23.9506L143.337 23.0399Z'
          fill='#781610'
        />
        <path
          d='M146.069 24.497C146.252 24.497 146.343 24.5881 146.525 24.5881L146.707 23.6774C146.525 23.6774 146.434 23.5864 146.252 23.5864L146.069 24.497Z'
          fill='#781610'
        />
        <path
          d='M134.049 61.0148L133.866 62.0165C134.049 62.0165 134.231 61.9254 134.322 61.9254L134.595 60.9237C134.413 60.9237 134.231 60.9237 134.049 61.0148Z'
          fill='#781610'
        />
        <path
          d='M137.236 62.4719C137.327 62.5629 137.509 62.7451 137.6 62.9272L137.874 61.8344C137.782 61.6523 137.6 61.5612 137.509 61.3791L137.236 62.4719Z'
          fill='#781610'
        />
        <path
          d='M103.906 121.574C103.45 122.576 99.079 126.036 99.079 126.036C99.079 126.036 99.9897 120.755 100.445 119.844L101.72 117.203L101.356 116.93L100.081 119.571C99.6254 120.572 98.8058 125.308 98.7147 125.854C98.7147 126.036 98.8058 126.219 98.8969 126.31C98.9879 126.31 99.079 126.401 99.1701 126.401C99.2611 126.401 99.3522 126.401 99.4433 126.31C100.172 125.672 103.906 122.667 104.452 121.665L105.545 119.48L105.18 119.206L103.906 121.574Z'
          fill='#781610'
        />
        <path
          d='M130.497 57.4632L128.949 60.6505C129.131 60.6505 129.222 60.7416 129.404 60.7416L131.681 56.0972L130.497 57.4632Z'
          fill='#781610'
        />
        <path
          d='M133.411 62.0165C133.32 62.0165 133.229 62.0165 133.047 62.0165L105.454 118.478L105.818 118.751L133.229 62.745L133.411 62.0165Z'
          fill='#781610'
        />
        <path
          d='M147.344 23.9506L155.358 7.46754C155.814 6.46581 156.997 6.10154 157.999 6.55687C159.001 7.01221 159.365 8.19607 158.91 9.1978L151.078 25.3166C151.26 25.4077 151.351 25.4077 151.533 25.4988L159.365 9.37995C159.638 8.83355 159.729 8.19608 159.456 7.55861C159.274 6.92115 158.819 6.46581 158.272 6.19261C157.726 5.91941 157.089 5.82834 156.451 6.10154C155.814 6.28367 155.358 6.739 155.085 7.2854L147.344 23.04L147.162 23.8596C147.162 23.8596 147.253 23.9506 147.344 23.9506Z'
          fill='#781610'
        />
        <path
          d='M150.714 26.9558L151.078 26.2273C150.896 26.1362 150.805 26.1362 150.623 26.0451L149.53 28.2307L150.714 26.9558Z'
          fill='#781610'
        />
        <path
          d='M128.494 61.5612L101.72 116.201L102.084 116.474L128.858 61.6522C128.767 61.6522 128.585 61.5612 128.494 61.5612Z'
          fill='#781610'
        />
        <path
          d='M102.084 116.474L101.72 116.201L101.356 117.021L101.72 117.294L102.084 116.474Z'
          fill='#781610'
        />
        <path
          d='M105.454 118.569L104.998 119.389L105.454 119.571L105.818 118.751L105.454 118.569Z'
          fill='#781610'
        />
        <path
          d='M146.98 24.7702L147.344 23.9506C147.253 23.9506 147.162 23.8595 147.071 23.8595L146.98 24.7702Z'
          fill='#781610'
        />
        <path
          d='M150.623 26.0452C150.805 26.1362 150.896 26.1362 151.078 26.2273L151.442 25.4077C151.26 25.3166 151.169 25.3166 150.987 25.2256L150.623 26.0452Z'
          fill='#781610'
        />
        <path
          d='M133.502 61.1059L133.047 62.1076C133.138 62.1076 133.229 62.1076 133.411 62.1076L133.502 61.1059C133.593 61.1059 133.593 61.1059 133.502 61.1059Z'
          fill='#781610'
        />
        <path
          d='M128.858 60.7415L128.494 61.5612C128.676 61.5612 128.767 61.6522 128.949 61.6522L129.404 60.8326C129.222 60.7415 129.04 60.7415 128.858 60.7415Z'
          fill='#781610'
        />
        <path
          d='M134.959 59.1024L136.417 56.1882C136.325 56.0972 136.143 56.0061 136.052 55.8239L135.415 57.0989L134.959 59.1024Z'
          fill='#781610'
        />
        <path
          d='M139.695 39.523L145.068 28.595L145.523 26.6826L139.786 38.4302L139.422 39.8873L139.695 39.523Z'
          fill='#781610'
        />
        <path
          d='M138.875 40.2516L138.602 40.889L138.784 40.6158L138.875 40.2516Z'
          fill='#781610'
        />
        <path
          d='M147.162 23.8595L147.344 23.0399L146.98 23.8595C146.98 23.8595 147.071 23.8595 147.162 23.8595Z'
          fill='#781610'
        />
        <path
          d='M145.978 26.7737L146.889 24.9523L146.98 24.6791C146.889 24.6791 146.707 24.588 146.616 24.588L146.525 24.7702L145.978 26.7737Z'
          fill='#781610'
        />
        <path
          d='M133.593 61.1058C133.776 61.1058 133.958 61.0147 134.049 61.0147L134.504 59.0113L133.593 60.8326V61.1058Z'
          fill='#781610'
        />
        <path
          d='M133.229 62.745L133.593 62.0165C133.502 62.0165 133.502 62.0165 133.411 62.0165L133.229 62.745Z'
          fill='#781610'
        />
        <path
          d='M146.889 24.7702L147.071 23.8595C146.98 23.8595 146.98 23.8595 146.889 23.7685L146.525 24.5881C146.616 24.6791 146.798 24.6791 146.889 24.7702Z'
          fill='#781610'
        />
        <path
          d='M133.593 61.1059L133.411 62.0165C133.502 62.0165 133.502 62.0165 133.593 62.0165L134.049 61.0148C133.958 61.0148 133.775 61.0148 133.593 61.1059Z'
          fill='#781610'
        />
        <path
          d='M146.434 24.8613L145.523 26.6826L145.068 28.595L145.979 26.7737L146.434 24.8613Z'
          fill='#781610'
        />
        <path
          d='M139.422 39.8873L139.786 38.4302L138.875 40.2516L138.784 40.6158L139.422 39.8873Z'
          fill='#781610'
        />
        <path
          d='M134.959 59.1024L135.415 57.1899L134.504 59.0113L134.14 60.9237L134.959 59.1024Z'
          fill='#781610'
        />
        <path
          d='M129.313 60.8326C129.495 60.8326 129.586 60.9237 129.768 60.9237L132.774 54.8222L131.59 56.1882L129.313 60.8326Z'
          fill='#781610'
        />
        <path
          d='M103.541 121.392C103.268 121.938 101.356 123.578 99.8075 124.944C100.172 122.94 100.627 120.664 100.9 120.117L102.175 117.567L101.811 117.294L100.536 119.935C100.081 120.937 99.17 126.128 99.17 126.128C99.17 126.128 103.541 122.576 103.997 121.665L105.089 119.48L104.725 119.206L103.541 121.392Z'
          fill='#781610'
        />
        <path
          d='M146.434 26.9558L147.435 24.8613C147.253 24.8613 147.162 24.7702 146.98 24.7702L146.889 24.9523L146.434 26.9558Z'
          fill='#781610'
        />
        <path
          d='M129.404 61.7433C129.222 61.7433 129.131 61.6523 128.949 61.6523L102.175 116.474L102.54 116.748L129.404 61.7433Z'
          fill='#781610'
        />
        <path
          d='M148.437 29.5967L149.621 28.2307L150.714 26.0451C150.532 25.9541 150.441 25.9541 150.259 25.863L148.437 29.5967Z'
          fill='#781610'
        />
        <path
          d='M133.684 60.8326L134.14 58.8292L133.047 61.1059C133.229 61.1059 133.411 61.1058 133.593 61.0148L133.684 60.8326Z'
          fill='#781610'
        />
        <path
          d='M155.814 7.64966C155.996 7.28539 156.269 7.01217 156.633 6.92111C156.815 6.83004 156.997 6.83003 157.089 6.83003C157.271 6.83003 157.544 6.92111 157.726 7.01218C158.09 7.19431 158.363 7.46751 158.455 7.83177C158.546 8.19604 158.546 8.65139 158.363 8.92459L150.441 25.0434C150.623 25.1345 150.714 25.1345 150.896 25.2255L158.728 9.1067C159.183 8.10497 158.819 7.01217 157.817 6.46577C156.815 5.91937 155.723 6.37471 155.176 7.37644L147.162 23.8595C147.344 23.8595 147.435 23.9506 147.618 23.9506L155.814 7.64966Z'
          fill='#781610'
        />
        <path
          d='M132.501 62.1076L104.998 118.296L105.363 118.569L132.956 62.1076C132.865 62.1076 132.683 62.1076 132.501 62.1076Z'
          fill='#781610'
        />
        <path
          d='M102.54 116.657L102.084 116.474L101.72 117.294L102.084 117.476L102.54 116.657Z'
          fill='#781610'
        />
        <path
          d='M104.634 119.115L104.998 119.389L105.454 118.569L104.998 118.296L104.634 119.115Z'
          fill='#781610'
        />
        <path
          d='M150.259 25.863C150.441 25.9541 150.532 25.9541 150.714 26.0451L151.078 25.2255C150.896 25.1345 150.805 25.1345 150.623 25.0434L150.259 25.863Z'
          fill='#781610'
        />
        <path
          d='M147.435 24.8613L147.8 24.0417C147.617 24.0417 147.526 23.9506 147.344 23.9506L146.98 24.7702C147.071 24.7702 147.253 24.8613 147.435 24.8613Z'
          fill='#781610'
        />
        <path
          d='M132.956 61.1059L132.5 62.0165C132.683 62.0165 132.865 62.0165 133.047 62.0165L133.502 61.0148C133.32 61.1058 133.138 61.1059 132.956 61.1059Z'
          fill='#781610'
        />
        <path
          d='M129.313 60.8326L128.858 61.6523C129.04 61.6523 129.131 61.7433 129.313 61.7433L129.768 60.9237C129.677 60.9237 129.495 60.8326 129.313 60.8326Z'
          fill='#781610'
        />
        <path
          d='M136.052 55.915C135.961 55.824 135.87 55.7329 135.779 55.6418L135.415 57.281L136.052 55.915Z'
          fill='#781610'
        />
        <path
          d='M144.612 30.5985L145.068 28.595L139.695 39.523L140.879 38.2481L144.612 30.5985Z'
          fill='#781610'
        />
        <path
          d='M146.434 26.9558L146.889 24.9524L145.978 26.7737L145.523 28.7771L146.434 26.9558Z'
          fill='#781610'
        />
        <path
          d='M134.504 59.0113L134.959 57.0079L134.14 58.8292L133.684 60.8326L134.504 59.0113Z'
          fill='#781610'
        />
        <path
          d='M134.504 59.0113L135.415 57.19L135.779 55.5508C135.779 55.5508 135.779 55.4597 135.688 55.4597L134.959 57.0079L134.504 59.0113Z'
          fill='#781610'
        />
        <path
          d='M145.523 28.7771L145.978 26.7737L145.068 28.595L144.612 30.5985L145.523 28.7771Z'
          fill='#781610'
        />
        <path
          d='M77.6783 112.923C77.5873 113.105 77.6784 113.287 77.7694 113.469C77.8605 113.56 77.9515 113.56 78.1337 113.56C78.2247 113.56 78.2248 113.56 78.3158 113.56C79.2265 113.196 83.5977 111.193 84.3262 110.373L86.6029 107.732L86.2386 107.459L83.962 110.009C83.2334 110.828 78.1337 113.105 78.1337 113.105C78.1337 113.105 80.3193 108.278 81.0478 107.459L82.8692 105.364L82.5049 105.091L80.6836 107.186C79.955 108.005 77.9515 112.467 77.6783 112.923Z'
          fill='#781610'
        />
        <path
          d='M131.226 55.915L127.401 60.2862C127.583 60.3773 127.674 60.3773 127.856 60.4684L130.406 57.5542L131.226 55.915Z'
          fill='#781610'
        />
        <path
          d='M163.281 13.2047C164.01 12.3851 165.193 12.2941 166.013 13.0226C166.833 13.7511 166.924 14.935 166.195 15.7546L155.631 27.8665C155.723 27.9575 155.905 28.0486 155.996 28.1397L166.559 16.0278C167.015 15.5725 167.197 14.935 167.106 14.2975C167.106 13.6601 166.742 13.1137 166.286 12.6583C165.831 12.203 165.193 12.0209 164.556 12.1119C163.919 12.1119 163.372 12.4762 162.917 12.9315L151.807 25.6809C151.989 25.7719 152.08 25.772 152.262 25.863L163.281 13.2047Z'
          fill='#781610'
        />
        <path
          d='M149.985 28.5039L151.716 26.5004C151.533 26.4094 151.442 26.4094 151.26 26.3183L150.714 26.9558L149.985 28.5039Z'
          fill='#781610'
        />
        <path
          d='M126.854 60.9237L86.8761 106.73L87.2404 107.003L127.31 61.1059C127.128 61.1059 126.945 61.0148 126.854 60.9237Z'
          fill='#781610'
        />
        <path
          d='M129.495 51.2706L123.667 58.0096C123.758 58.1006 123.849 58.1917 124.031 58.2828L129.951 51.4527C129.86 51.3617 129.678 51.2706 129.495 51.2706Z'
          fill='#781610'
        />
        <path
          d='M143.337 41.9818L142.7 43.3478C142.791 43.3478 142.791 43.2567 142.882 43.2567L155.449 28.7771C155.358 28.6861 155.176 28.595 155.085 28.5039L143.337 41.9818Z'
          fill='#781610'
        />
        <path
          d='M135.961 44.5317C136.325 44.0764 136.598 43.53 136.781 42.8925L133.229 46.9905C133.775 46.7173 134.322 46.353 134.777 45.8977L135.961 44.5317Z'
          fill='#781610'
        />
        <path
          d='M132.774 48.2654C132.501 48.3565 132.227 48.4476 131.954 48.5386L130.133 50.6332C130.315 50.7242 130.406 50.7242 130.588 50.8153L132.774 48.2654Z'
          fill='#781610'
        />
        <path
          d='M123.394 58.9203C123.303 58.8292 123.212 58.7381 123.03 58.6471L83.0513 104.454L83.4155 104.727L123.394 58.9203Z'
          fill='#781610'
        />
        <path
          d='M83.5066 104.727L83.1423 104.454L82.5049 105.182L82.8692 105.364L83.5066 104.727Z'
          fill='#781610'
        />
        <path
          d='M86.785 106.821L86.2386 107.459L86.6029 107.732L87.2404 107.003L86.785 106.821Z'
          fill='#781610'
        />
        <path
          d='M134.777 45.8977C134.322 46.353 133.775 46.7173 133.229 46.9905L131.954 48.4476C132.227 48.3565 132.5 48.2654 132.774 48.1744L134.777 45.8977Z'
          fill='#781610'
        />
        <path
          d='M155.085 28.595C155.176 28.6861 155.358 28.7772 155.449 28.8682L156.087 28.1397C155.996 28.0486 155.814 27.9576 155.723 27.8665L155.085 28.595Z'
          fill='#781610'
        />
        <path
          d='M151.715 26.5915L152.353 25.863C152.171 25.772 152.08 25.7719 151.898 25.6809L151.26 26.4094C151.351 26.4094 151.533 26.5005 151.715 26.5915Z'
          fill='#781610'
        />
        <path
          d='M137.965 42.0729L138.147 41.3444L136.781 42.8925C136.507 43.53 136.234 44.0764 135.961 44.5317L137.782 42.4372L137.965 42.0729Z'
          fill='#781610'
        />
        <path
          d='M130.588 50.7242C130.406 50.6332 130.315 50.6332 130.133 50.5421L129.495 51.2706C129.677 51.3617 129.769 51.3617 129.951 51.4528L130.588 50.7242Z'
          fill='#781610'
        />
        <path
          d='M127.401 60.1952L126.763 60.9237C126.946 61.0148 127.037 61.0148 127.219 61.1059L127.856 60.3773C127.765 60.3773 127.583 60.2863 127.401 60.1952Z'
          fill='#781610'
        />
        <path
          d='M124.031 58.2828C123.94 58.1917 123.849 58.1006 123.667 58.0096L123.03 58.7381C123.121 58.8292 123.212 58.9202 123.394 59.0113L124.031 58.2828Z'
          fill='#781610'
        />
        <path
          d='M138.602 40.889L138.238 41.2533C138.147 41.4354 138.147 41.7086 138.056 41.8908L138.602 40.889Z'
          fill='#781610'
        />
        <path
          d='M137.964 42.0729L138.056 41.8907C138.147 41.7086 138.147 41.4354 138.238 41.2533L138.147 41.3443L137.964 42.0729Z'
          fill='#781610'
        />
        <path
          d='M144.612 34.6054L147.618 31.1449L148.437 29.5967L144.886 33.6947L144.612 34.6054Z'
          fill='#781610'
        />
        <path
          d='M132.774 54.8222L134.777 52.4545H134.686C134.504 52.4545 134.413 52.4545 134.231 52.4545L133.593 53.2741L132.774 54.8222Z'
          fill='#781610'
        />
        <path
          d='M134.231 52.4545C134.413 52.4545 134.595 52.4545 134.686 52.4545H134.777L134.868 52.2724C134.868 52.0902 134.868 51.9992 134.868 51.817C134.868 51.726 134.868 51.6349 134.959 51.4528L134.231 52.4545Z'
          fill='#781610'
        />
        <path
          d='M143.611 35.1518L140.879 38.2481L140.15 39.7962L143.337 36.0625L143.611 35.1518Z'
          fill='#781610'
        />
        <path
          d='M143.975 35.334L144.612 34.6054L144.886 33.6947L144.248 34.4233L143.975 35.334Z'
          fill='#781610'
        />
        <path
          d='M143.337 36.0625L143.975 35.3339L144.248 34.4233L143.611 35.1518L143.337 36.0625Z'
          fill='#781610'
        />
        <path
          d='M142.609 43.4389C142.609 43.4389 142.7 43.4389 142.7 43.3478L143.337 41.9818L142.7 42.7104L142.609 43.4389Z'
          fill='#781610'
        />
        <path
          d='M131.59 56.1882L132.409 54.549L131.226 55.915L130.497 57.4632L131.59 56.1882Z'
          fill='#781610'
        />
        <path
          d='M149.985 28.504L150.714 26.9558L149.53 28.3218L148.802 29.87L149.985 28.504Z'
          fill='#781610'
        />
        <path
          d='M137.965 42.0729L137.782 42.4381L137.965 42.3468V42.0729Z'
          fill='#781610'
        />
        <path
          d='M139.695 39.523L139.422 39.8873L139.33 40.4337L139.695 39.523Z'
          fill='#781610'
        />
        <path
          d='M137.964 42.255L138.602 41.5265L138.784 40.6158L138.602 40.889L138.056 41.8907C138.056 42.0729 137.964 42.164 137.964 42.255Z'
          fill='#781610'
        />
        <path
          d='M142.062 43.53V43.621C142.154 43.53 142.245 43.53 142.336 43.4389C142.427 43.4389 142.518 43.3478 142.518 43.3478L142.7 42.6193L142.154 43.2567L142.062 43.53Z'
          fill='#781610'
        />
        <path
          d='M137.964 42.256C137.964 42.1647 138.056 41.9821 138.056 41.8907L137.964 42.0734V42.256Z'
          fill='#781610'
        />
        <path
          d='M139.331 40.4337L139.422 39.8873L138.784 40.6158L138.602 41.6176L138.966 41.1622L139.331 40.4337Z'
          fill='#781610'
        />
        <path
          d='M132.409 54.5491L131.59 56.1883L132.774 54.8223L133.502 53.2741L132.409 54.5491Z'
          fill='#781610'
        />
        <path
          d='M148.801 29.87L149.53 28.3218L148.437 29.5967L147.618 31.1449L148.801 29.87Z'
          fill='#781610'
        />
        <path
          d='M139.24 40.889L140.15 39.7962L140.879 38.2481L139.695 39.523L139.331 40.4337L139.24 40.889Z'
          fill='#781610'
        />
        <path
          d='M142.245 43.2567L142.154 43.4394L142.062 43.5307L142.245 43.2567Z'
          fill='#781610'
        />
        <path
          d='M142.154 43.4389L141.789 43.8942C141.88 43.8942 141.971 43.8032 142.063 43.8032L142.154 43.621V43.4389Z'
          fill='#781610'
        />
        <path
          d='M139.33 40.4337L138.966 41.1622L139.239 40.889L139.33 40.4337Z'
          fill='#781610'
        />
        <path
          d='M83.5977 109.735C83.2334 110.191 80.9567 111.284 79.0443 112.194C79.8639 110.373 80.9567 108.278 81.4121 107.823L83.3245 105.637L82.9602 105.364L81.1389 107.459C80.4103 108.278 78.2247 113.105 78.2247 113.105C78.2247 113.105 83.4155 110.828 84.053 110.009L86.3297 107.459L85.9654 107.186L83.5977 109.735Z'
          fill='#781610'
        />
        <path
          d='M130.406 51.6349C130.224 51.5438 130.133 51.5438 129.951 51.4528L124.031 58.2828C124.122 58.3738 124.305 58.4649 124.396 58.556L130.406 51.6349Z'
          fill='#781610'
        />
        <path
          d='M131.226 55.915L131.954 54.3669L126.945 60.1041C127.128 60.1951 127.219 60.1952 127.401 60.2862L131.226 55.915Z'
          fill='#781610'
        />
        <path
          d='M123.758 59.1934C123.667 59.1023 123.485 59.0113 123.394 58.9202L83.4154 104.727L83.7797 105L123.758 59.1934Z'
          fill='#781610'
        />
        <path
          d='M149.166 30.1432L152.08 26.7737C151.898 26.6826 151.807 26.5916 151.625 26.5916L149.894 28.595L149.166 30.1432Z'
          fill='#781610'
        />
        <path
          d='M144.157 40.4337L143.428 41.9818L155.085 28.595C154.994 28.504 154.812 28.4129 154.721 28.3218L144.157 40.4337Z'
          fill='#781610'
        />
        <path
          d='M133.775 47.8101C133.411 47.9922 133.138 48.1744 132.774 48.2654L130.588 50.7242C130.77 50.8153 130.861 50.8153 131.043 50.9064L133.775 47.8101Z'
          fill='#781610'
        />
        <path
          d='M163.645 13.4779C163.919 13.2047 164.283 13.0226 164.647 12.9315H164.738C165.103 12.9315 165.467 13.0226 165.74 13.2958C166.013 13.569 166.195 13.9333 166.286 14.2975C166.286 14.6618 166.195 15.1171 165.922 15.3903L155.358 27.5022C155.449 27.5933 155.632 27.6843 155.723 27.7754L166.286 15.6635C167.015 14.8439 166.924 13.6601 166.104 12.9315C165.285 12.203 164.101 12.2941 163.372 13.1137L152.353 25.7719C152.535 25.863 152.626 25.9541 152.808 25.9541L163.645 13.4779Z'
          fill='#781610'
        />
        <path
          d='M135.779 44.8049C135.87 44.7138 135.87 44.6228 135.961 44.5317L134.777 45.8977C135.141 45.6245 135.506 45.2602 135.779 44.8049Z'
          fill='#781610'
        />
        <path
          d='M126.399 60.7415L86.4208 106.548L86.785 106.821L126.763 61.0147C126.672 60.9237 126.49 60.8326 126.399 60.7415Z'
          fill='#781610'
        />
        <path
          d='M86.4207 106.548L85.7832 107.277L86.2385 107.459L86.7849 106.821L86.4207 106.548Z'
          fill='#781610'
        />
        <path
          d='M83.8709 104.909L83.5066 104.727L82.8691 105.364L83.2334 105.638L83.8709 104.909Z'
          fill='#781610'
        />
        <path
          d='M154.721 28.3218C154.812 28.4129 154.994 28.5039 155.085 28.595L155.723 27.8665C155.631 27.7754 155.449 27.6843 155.358 27.5933L154.721 28.3218Z'
          fill='#781610'
        />
        <path
          d='M137.054 44.0763L137.782 42.5282L135.961 44.6227C135.87 44.7138 135.87 44.8049 135.779 44.8959C135.506 45.2602 135.141 45.6245 134.777 45.9887L132.774 48.2654C133.138 48.1743 133.411 47.9922 133.775 47.8101L137.054 44.0763Z'
          fill='#781610'
        />
        <path
          d='M152.717 26.0451C152.535 25.9541 152.444 25.863 152.262 25.863L151.625 26.5915C151.807 26.6826 151.898 26.7737 152.08 26.7737L152.717 26.0451Z'
          fill='#781610'
        />
        <path
          d='M130.588 50.7242L129.951 51.4528C130.133 51.5438 130.224 51.5438 130.406 51.6349L131.043 50.9064C130.952 50.8153 130.77 50.7242 130.588 50.7242Z'
          fill='#781610'
        />
        <path
          d='M127.037 60.0131L126.399 60.7416C126.581 60.8327 126.672 60.8327 126.855 60.9237L127.492 60.1952C127.31 60.1952 127.128 60.1041 127.037 60.0131Z'
          fill='#781610'
        />
        <path
          d='M124.396 58.556C124.304 58.4649 124.122 58.3738 124.031 58.2828L123.394 58.9203C123.485 59.0113 123.667 59.1024 123.758 59.1934L124.396 58.556Z'
          fill='#781610'
        />
        <path
          d='M135.05 51.5439C135.141 51.2707 135.141 50.9064 135.232 50.6332L134.413 51.5439C134.686 51.5439 134.868 51.5439 135.05 51.5439Z'
          fill='#781610'
        />
        <path
          d='M146.889 32.7841L147.618 31.1449L144.612 34.6054L144.43 35.6072L146.889 32.7841Z'
          fill='#781610'
        />
        <path
          d='M133.502 53.2741L134.14 52.4545C134.049 52.4545 133.958 52.4545 133.866 52.4545L133.502 53.2741Z'
          fill='#781610'
        />
        <path
          d='M133.958 52.4545C134.049 52.4545 134.14 52.4545 134.231 52.4545L135.05 51.5439C134.868 51.5439 134.686 51.5439 134.413 51.5439L134.322 51.6349L133.958 52.4545Z'
          fill='#781610'
        />
        <path
          d='M140.15 39.7962L139.33 41.3444L143.155 37.0642L143.337 36.0625L140.15 39.7962Z'
          fill='#781610'
        />
        <path
          d='M141.698 43.1657L140.605 44.3496C140.879 44.2585 141.061 44.0764 141.334 43.9853L141.607 43.3478L141.698 43.1657Z'
          fill='#781610'
        />
        <path
          d='M143.793 36.3357L144.43 35.6071L144.612 34.6054L143.975 35.334L143.793 36.3357Z'
          fill='#781610'
        />
        <path
          d='M141.698 43.3485L141.881 43.0746L141.698 43.166V43.3485Z'
          fill='#781610'
        />
        <path
          d='M143.975 35.334L143.337 36.0625L143.155 37.0642L143.793 36.3357L143.975 35.334Z'
          fill='#781610'
        />
        <path
          d='M142.973 41.7086L142.791 42.7104L143.337 41.9818L144.157 40.4337L142.973 41.7086Z'
          fill='#781610'
        />
        <path
          d='M132.409 54.549L133.138 53.0009L132.045 54.2758L131.225 55.915L132.409 54.549Z'
          fill='#781610'
        />
        <path
          d='M137.6 43.4389L137.782 43.2567L137.964 42.6193C137.782 42.8925 137.691 43.1657 137.6 43.4389Z'
          fill='#781610'
        />
        <path
          d='M147.982 31.4181L149.166 30.1431L149.985 28.5039L148.801 29.8699L147.982 31.4181Z'
          fill='#781610'
        />
        <path
          d='M137.873 42.6193L137.965 42.3461L137.873 42.5282L137.145 44.0764L137.691 43.4389C137.691 43.1657 137.782 42.8925 137.873 42.6193Z'
          fill='#781610'
        />
        <path
          d='M137.691 43.2567L138.147 42.7104L138.42 42.255L138.602 41.6176L137.964 42.3461C137.964 42.4371 137.873 42.5282 137.873 42.6193L137.691 43.2567Z'
          fill='#781610'
        />
        <path
          d='M142.791 42.7104L142.973 41.7086L142.245 43.2568L142.791 42.7104Z'
          fill='#781610'
        />
        <path
          d='M137.873 42.62C137.873 42.5287 137.965 42.4374 137.965 42.3461L137.873 42.62Z'
          fill='#781610'
        />
        <path
          d='M138.966 41.1622L138.602 41.6175L138.42 42.255L138.966 41.1622Z'
          fill='#781610'
        />
        <path
          d='M133.958 52.4545C133.866 52.4545 133.775 52.4545 133.684 52.4545L133.138 53.0009L132.409 54.5491L133.593 53.1831L133.958 52.4545Z'
          fill='#781610'
        />
        <path
          d='M147.982 31.4181L148.802 29.87L147.618 31.1449L146.889 32.7841L147.982 31.4181Z'
          fill='#781610'
        />
        <path
          d='M134.322 51.6349L133.684 52.3634C133.776 52.3634 133.867 52.3634 133.958 52.3634L134.322 51.6349Z'
          fill='#781610'
        />
        <path
          d='M141.698 43.3478L141.425 43.9853C141.516 43.9853 141.516 43.8942 141.607 43.8942L141.698 43.3478Z'
          fill='#781610'
        />
        <path
          d='M139.239 40.889L138.966 41.7997L139.33 41.3444L140.15 39.7962L139.239 40.889Z'
          fill='#781610'
        />
        <path
          d='M142.336 42.4372L142.154 43.4389L142.245 43.2568L142.973 41.7086L142.336 42.4372Z'
          fill='#781610'
        />
        <path
          d='M138.42 42.255L138.147 42.7104L138.329 42.5282L138.42 42.255Z'
          fill='#781610'
        />
        <path
          d='M138.966 41.7997L139.24 40.889L138.966 41.1622L138.42 42.255L138.329 42.5282L138.966 41.7997Z'
          fill='#781610'
        />
        <path
          d='M142.336 42.4371L141.789 42.9835L141.607 43.3478L141.516 43.8942C141.607 43.8942 141.698 43.8031 141.698 43.8031L142.063 43.3478L142.336 42.4371Z'
          fill='#781610'
        />
        <path
          d='M143.611 43.0746V43.2567C143.246 43.621 142.882 43.8942 142.427 44.0764L142.336 44.1674C142.245 44.2585 142.063 44.2585 141.971 44.3495C141.88 44.3495 141.789 44.4406 141.698 44.4406C141.607 44.4406 141.516 44.5317 141.425 44.5317C141.334 44.5317 141.152 44.6227 141.061 44.6227C140.788 44.7138 140.514 44.8049 140.15 44.896C139.331 45.1692 138.602 45.5334 137.965 46.0798C137.965 46.0798 137.965 46.0798 137.873 46.1709C137.691 46.353 137.418 46.6262 137.236 46.8994C136.963 47.2637 136.69 47.628 136.507 48.0833C136.234 48.6297 135.961 49.2672 135.779 49.8136C135.688 50.0868 135.597 50.2689 135.597 50.5421C135.597 50.6331 135.597 50.7242 135.506 50.8153C135.506 50.9974 135.415 51.2706 135.415 51.4527C135.597 51.4527 135.688 51.6349 135.779 51.7259C135.87 51.9991 135.688 52.1813 135.506 52.2724H135.415C135.415 52.4545 135.415 52.7277 135.415 52.9098C135.415 53.183 135.415 53.3652 135.506 53.6384C135.506 53.8205 135.597 54.0026 135.597 54.1847C135.688 54.4579 135.779 54.6401 135.961 54.8222C135.961 54.8222 135.961 54.8222 135.961 54.9133C136.052 55.0043 136.143 55.1865 136.325 55.2776C136.416 55.3686 136.599 55.4597 136.69 55.5508C136.872 55.6418 137.054 55.7329 137.236 55.8239C137.327 55.8239 137.327 55.824 137.418 55.915L137.509 55.8239C137.691 55.7329 137.965 55.824 138.147 56.0061C138.329 56.0061 138.511 56.0061 138.693 56.0061C138.875 56.0061 139.057 55.915 139.239 55.8239C139.422 55.7329 139.604 55.6418 139.786 55.5508C140.788 55.0043 141.698 54.1847 142.7 53.7294C143.52 53.0009 144.248 52.3634 145.159 52.1813C147.982 51.6349 150.623 51.817 153.355 52.8187C156.36 53.9115 161.824 53.183 164.01 48.3565C164.101 48.0833 164.01 47.9012 163.827 47.719C163.554 47.628 163.372 47.719 163.19 47.9011C161.187 52.1813 156.36 52.8188 153.628 51.817C150.714 50.7242 147.891 50.5421 144.886 51.1796C143.52 51.4528 142.427 52.5456 141.334 53.6384C140.15 54.8222 138.966 56.0061 137.691 55.6419C135.415 55.1865 135.779 51.817 135.779 51.817C136.234 47.3548 139.513 45.7155 142.7 44.1674C144.248 43.4389 145.705 42.7104 146.798 41.7086C147.8 40.798 148.528 39.8873 149.166 39.0677C147.982 40.0694 146.707 40.9801 145.432 41.8907C144.977 42.4371 144.248 43.0746 143.611 43.0746Z'
          fill='#781610'
        />
        <path
          d='M150.623 34.6965C150.35 34.6965 150.167 34.8786 150.076 35.0607C150.076 35.0607 149.621 38.157 146.252 41.0711C145.341 41.8907 144.066 42.5282 142.791 43.1657L142.518 43.4389L142.427 43.621L142.336 43.9853C142.791 43.8032 143.155 43.53 143.52 43.1657V42.9836C144.248 42.9836 144.886 42.3461 145.432 41.8907C146.707 40.9801 147.891 40.0694 149.166 39.0677C150.623 36.8821 150.896 35.1518 150.896 35.0607C150.987 34.9697 150.805 34.7875 150.623 34.6965Z'
          fill='#781610'
        />
        <path
          d='M139.604 56.4614C140.514 56.0061 141.334 55.1865 142.063 54.4579C142.245 54.2758 142.518 54.0027 142.7 53.8205C141.607 54.2759 140.788 55.0955 139.786 55.6419L139.604 56.4614Z'
          fill='#781610'
        />
        <path
          d='M135.415 52.3634H135.506C135.779 52.2724 135.87 51.9992 135.779 51.817C135.688 51.6349 135.597 51.5439 135.415 51.5439C135.415 51.6349 135.415 51.6349 135.415 51.7259C135.506 51.9081 135.415 52.1813 135.415 52.3634Z'
          fill='#781610'
        />
        <path
          d='M138.056 56.0972C137.964 55.915 137.691 55.824 137.418 55.915C137.418 55.915 137.327 55.915 137.327 56.0061C137.6 56.0061 137.873 56.0972 138.056 56.0972Z'
          fill='#781610'
        />
        <path
          d='M137.327 56.6436C137.327 56.5525 137.236 56.4614 137.236 56.4614C137.145 56.2793 137.236 56.0061 137.327 55.915C137.236 55.915 137.236 55.915 137.145 55.8239C136.963 55.7329 136.781 55.6418 136.599 55.5508L136.325 56.1882C136.69 56.3704 136.963 56.5525 137.327 56.6436Z'
          fill='#781610'
        />
        <path
          d='M138.602 56.7346L138.784 56.0061C138.602 56.0061 138.42 56.0971 138.238 56.0061C138.238 56.0971 138.329 56.3703 138.42 56.7346C138.42 56.8257 138.511 56.8257 138.602 56.7346Z'
          fill='#781610'
        />
        <path
          d='M137.327 56.4614C137.327 56.4614 137.327 56.5525 137.418 56.6436C137.509 56.6436 137.6 56.7346 137.691 56.7346C137.873 56.8257 138.147 56.8257 138.329 56.8257C138.329 56.8257 138.329 56.8257 138.42 56.8257C138.42 56.4614 138.329 56.1883 138.238 56.0972C137.965 56.0972 137.782 56.0061 137.509 55.915C137.236 56.0972 137.236 56.2793 137.327 56.4614Z'
          fill='#781610'
        />
        <path
          d='M139.24 55.915L139.057 56.6436C139.24 56.5525 139.422 56.5525 139.604 56.4614L139.786 55.6418C139.604 55.7329 139.422 55.824 139.24 55.915Z'
          fill='#781610'
        />
        <path
          d='M142.427 44.0764L142.518 43.7121L142.336 44.1674L142.427 44.0764Z'
          fill='#781610'
        />
        <path
          d='M138.784 56.0972L138.602 56.8257C138.784 56.8257 138.966 56.7346 139.057 56.7346L139.24 56.0061C139.057 56.0061 138.875 56.0061 138.784 56.0972Z'
          fill='#781610'
        />
        <path
          d='M135.141 54.2759L135.415 53.092C135.415 52.9098 135.415 52.6367 135.415 52.4545C135.232 52.4545 135.141 52.5456 134.868 52.5456C134.959 53.0009 134.959 53.6384 135.141 54.2759Z'
          fill='#781610'
        />
        <path
          d='M134.959 52.3634V52.4545C135.142 52.4545 135.324 52.4545 135.506 52.3634C135.506 52.0902 135.506 51.9081 135.597 51.6349L134.959 52.3634Z'
          fill='#781610'
        />
        <path
          d='M135.506 55.0044L135.688 54.2758C135.597 54.0937 135.597 53.9115 135.597 53.7294C135.597 53.4562 135.506 53.2741 135.506 53.0009L135.233 54.1847C135.233 54.549 135.324 54.7312 135.506 55.0044Z'
          fill='#781610'
        />
        <path
          d='M135.779 55.4597L135.961 55.1865L136.052 54.9133C135.961 54.7311 135.779 54.549 135.688 54.2758L135.506 55.0044C135.506 55.1865 135.688 55.3686 135.779 55.4597Z'
          fill='#781610'
        />
        <path
          d='M142.518 43.7126L142.609 43.53L142.518 43.6213V43.7126Z'
          fill='#781610'
        />
        <path
          d='M136.416 56.1883L136.69 55.5508C136.507 55.4597 136.416 55.3687 136.325 55.2776L136.052 55.824C136.143 56.0061 136.325 56.0972 136.416 56.1883Z'
          fill='#781610'
        />
        <path
          d='M141.971 44.2585C142.063 44.1674 142.245 44.1674 142.336 44.0764L142.518 43.621V43.53L141.971 44.2585Z'
          fill='#781610'
        />
        <path
          d='M135.779 55.5508C135.87 55.6418 135.961 55.7329 136.052 55.824L136.325 55.2776C136.234 55.1865 136.052 55.0954 135.961 54.9133L135.87 55.0954L135.779 55.5508Z'
          fill='#781610'
        />
        <path
          d='M135.87 55.1865L135.688 55.4604C135.688 55.4604 135.688 55.5517 135.779 55.5517L135.87 55.1865Z'
          fill='#781610'
        />
        <path
          d='M135.141 50.6332L135.87 49.8136C136.052 49.1761 136.325 48.6297 136.598 48.0833L136.781 47.3548C136.052 48.2654 135.506 49.3583 135.141 50.6332Z'
          fill='#781610'
        />
        <path
          d='M137.964 46.1709C138.602 45.5334 139.422 45.1692 140.15 44.896L140.605 44.3496C139.695 44.896 138.784 45.5334 137.964 46.1709Z'
          fill='#781610'
        />
        <path
          d='M136.781 47.4458L136.598 48.1744C136.781 47.719 137.054 47.3548 137.327 46.9905L137.418 46.8084C137.145 46.9905 136.963 47.1726 136.781 47.4458Z'
          fill='#781610'
        />
        <path
          d='M137.418 46.7173L137.327 46.8994C137.509 46.6262 137.782 46.353 137.965 46.1709C137.782 46.353 137.6 46.5352 137.418 46.7173Z'
          fill='#781610'
        />
        <path
          d='M142.883 43.2567C142.791 43.2567 142.792 43.3481 142.7 43.3481L142.609 43.5307L142.883 43.2567Z'
          fill='#781610'
        />
        <path
          d='M135.05 51.5439C135.141 51.5439 135.232 51.5439 135.323 51.5439C135.415 51.5439 135.506 51.5439 135.597 51.5439C135.597 51.3617 135.688 51.0885 135.688 50.9064L135.05 51.5439Z'
          fill='#781610'
        />
        <path
          d='M135.232 51.5439C135.141 51.5439 135.05 51.5439 134.959 51.5439C134.959 51.6349 134.959 51.726 134.868 51.9081C134.868 51.9992 134.868 52.1813 134.868 52.3634L135.415 51.7259C135.415 51.6349 135.415 51.6349 135.415 51.5439C135.415 51.4528 135.324 51.4528 135.232 51.5439Z'
          fill='#781610'
        />
        <path
          d='M142.518 43.6217L142.7 43.3478C142.7 43.3478 142.609 43.3478 142.609 43.4391L142.518 43.6217Z'
          fill='#781610'
        />
        <path
          d='M142.609 43.4389C142.518 43.4389 142.427 43.53 142.427 43.53C142.336 43.621 142.245 43.621 142.154 43.7121L141.971 44.3496L142.609 43.621V43.4389Z'
          fill='#781610'
        />
        <path
          d='M142.063 43.7121L141.698 44.4406C141.789 44.4406 141.88 44.3495 141.971 44.3495L142.063 43.7121Z'
          fill='#781610'
        />
        <path
          d='M141.061 44.6227C141.152 44.6227 141.243 44.5317 141.425 44.5317L141.516 44.1674L141.061 44.6227Z'
          fill='#781610'
        />
        <path
          d='M141.789 43.8031L141.516 44.0764L141.425 44.4406C141.516 44.4406 141.607 44.3496 141.698 44.3496L142.063 43.621C141.971 43.7121 141.88 43.8031 141.789 43.8031Z'
          fill='#781610'
        />
        <path
          d='M135.05 51.5439L135.688 50.8153C135.688 50.7242 135.688 50.6332 135.779 50.5421C135.87 50.2689 135.87 50.0868 135.961 49.8136L135.232 50.6332C135.141 50.9975 135.05 51.2707 135.05 51.5439Z'
          fill='#781610'
        />
        <path
          d='M141.334 44.0764C141.061 44.1674 140.879 44.3495 140.605 44.4406L140.15 44.987C140.423 44.896 140.697 44.8049 141.061 44.7138L141.334 44.0764Z'
          fill='#781610'
        />
        <path
          d='M141.334 44.0764L141.061 44.6227L141.516 44.1674V43.9853C141.516 43.9853 141.425 43.9853 141.334 44.0764Z'
          fill='#781610'
        />
        <path
          d='M141.516 44.1681L141.79 43.8942C141.699 43.8942 141.607 43.9855 141.607 43.9855L141.516 44.1681Z'
          fill='#781610'
        />
        <path
          d='M62.288 109.462C62.4701 109.371 62.6523 109.098 62.4701 108.825C62.3791 108.643 62.1059 108.461 61.8327 108.643C53.1813 112.923 40.9784 119.844 32.327 129.133C32.1449 129.315 32.1449 129.588 32.327 129.77C32.4181 129.861 32.5092 129.861 32.6002 129.861C32.6913 129.861 32.8734 129.77 32.9645 129.679C41.6158 120.573 53.7277 113.651 62.288 109.462Z'
          fill='#781610'
        />
        <path
          d='M64.3826 111.284C64.5647 111.193 64.7469 110.919 64.5647 110.646C64.4737 110.464 64.2005 110.373 63.9273 110.464C55.2759 114.744 43.073 121.665 34.4216 130.954C34.2395 131.136 34.2395 131.409 34.4216 131.591C34.5127 131.683 34.6038 131.683 34.6948 131.683C34.7859 131.683 34.968 131.592 35.0591 131.5C43.7104 122.485 55.8223 115.473 64.3826 111.284Z'
          fill='#781610'
        />
        <path
          d='M56.2776 118.296C56.1865 118.114 55.9133 118.023 55.6401 118.114C47.7173 122.849 41.2516 127.858 36.334 133.049C36.1519 133.231 36.1519 133.504 36.334 133.686C36.4251 133.777 36.5161 133.777 36.6072 133.777C36.6983 133.777 36.8804 133.686 36.9715 133.595C41.798 128.404 48.2637 123.487 56.0044 118.842C56.2776 118.751 56.3687 118.478 56.2776 118.296Z'
          fill='#781610'
        />
        <path
          d='M52.3617 143.248C52.1796 143.43 52.1796 143.703 52.3617 143.885C52.4528 143.977 52.5438 143.977 52.6349 143.977C52.726 143.977 52.9081 143.886 52.9992 143.794C60.7398 135.598 71.0304 129.042 79.4996 124.579C79.3174 124.306 79.0442 124.124 78.8621 123.851C70.3929 128.495 60.1024 135.052 52.3617 143.248Z'
          fill='#781610'
        />
        <path
          d='M84.1439 122.303C84.3261 122.212 84.5082 121.938 84.3261 121.665C84.235 121.483 83.9618 121.392 83.6886 121.483C82.1405 122.212 80.5923 123.031 78.8621 123.942C79.0442 124.215 79.3174 124.397 79.4995 124.67C81.1387 123.76 82.6869 123.031 84.1439 122.303Z'
          fill='#781610'
        />
        <path
          d='M54.5474 145.252C54.3652 145.434 54.3652 145.707 54.5474 145.889C54.6384 145.98 54.7295 145.98 54.8206 145.98C54.9116 145.98 55.0938 145.889 55.1848 145.798C62.8344 137.693 73.0339 131.136 81.5031 126.674C81.321 126.492 81.0478 126.219 80.8657 126.036C72.3964 130.59 62.197 137.056 54.5474 145.252Z'
          fill='#781610'
        />
        <path
          d='M86.3297 124.306C86.5119 124.215 86.694 123.942 86.5119 123.669C86.4208 123.487 86.1476 123.396 85.8744 123.487C84.3263 124.306 82.596 125.126 80.8657 126.036C81.0479 126.219 81.3211 126.492 81.5032 126.674C83.2335 125.854 84.8727 125.035 86.3297 124.306Z'
          fill='#781610'
        />
        <path
          d='M77.6784 131.683C77.5873 131.5 77.3141 131.409 77.0409 131.5C68.6628 136.509 61.7417 141.882 56.5509 147.346C56.3688 147.528 56.3688 147.801 56.5509 147.984C56.642 148.075 56.733 148.075 56.8241 148.075C56.9152 148.075 57.0973 147.984 57.1884 147.892C62.2881 142.428 69.1181 137.147 77.4963 132.138C77.7695 132.229 77.7695 131.956 77.6784 131.683Z'
          fill='#781610'
        />
        <path
          d='M102.904 134.323C103.086 134.232 103.268 133.959 103.086 133.686C102.995 133.504 102.722 133.413 102.449 133.504C100.263 134.597 97.8952 135.781 95.3453 137.238C95.6185 137.42 95.9828 137.602 96.256 137.784C98.7148 136.509 100.9 135.325 102.904 134.323Z'
          fill='#781610'
        />
        <path
          d='M70.2108 155.997C70.0287 156.18 70.0287 156.453 70.2108 156.635C70.3019 156.726 70.393 156.726 70.484 156.726C70.5751 156.726 70.7572 156.635 70.8483 156.544C78.2247 148.712 87.9688 142.337 96.347 137.693C96.0738 137.511 95.7095 137.329 95.4363 137.147C87.0582 141.791 77.4962 148.166 70.2108 155.997Z'
          fill='#781610'
        />
        <path
          d='M105.18 136.327C105.363 136.236 105.545 135.963 105.363 135.69C105.272 135.507 104.998 135.416 104.725 135.507C102.722 136.509 100.627 137.602 98.3505 138.786C98.7147 138.968 98.9879 139.15 99.3522 139.241C101.447 138.239 103.359 137.238 105.18 136.327Z'
          fill='#781610'
        />
        <path
          d='M72.4877 158.001C72.3055 158.183 72.3055 158.456 72.4877 158.638C72.5787 158.729 72.6698 158.729 72.7609 158.729C72.8519 158.729 73.0341 158.638 73.1251 158.547C80.7747 150.442 90.8832 143.886 99.4434 139.241C99.0792 139.059 98.806 138.877 98.4417 138.786C89.9725 143.521 80.0462 149.987 72.4877 158.001Z'
          fill='#781610'
        />
        <path
          d='M96.0738 144.705C96.2559 144.614 96.347 144.341 96.2559 144.068C96.1649 143.885 95.8917 143.794 95.6185 143.885C86.9671 149.076 79.8639 154.54 74.491 160.278C74.3088 160.46 74.3088 160.733 74.491 160.915C74.582 161.006 74.6731 161.006 74.7642 161.006C74.8552 161.006 75.0374 160.915 75.1284 160.824C80.5014 155.269 87.5135 149.805 96.0738 144.705Z'
          fill='#781610'
        />
        <path
          d='M20.7616 135.872C20.7616 135.598 20.4884 135.416 20.2152 135.507C11.3817 136.873 3.09463 139.605 -2.73364 141.791V142.793C3.00356 140.607 11.4728 137.875 20.3973 136.418C20.6705 136.327 20.8526 136.145 20.7616 135.872Z'
          fill='#781610'
        />
        <path
          d='M23.4936 138.422C23.4936 138.148 23.2204 137.966 22.9472 138.057C12.7477 139.879 3.36783 143.066 -2.73364 145.525V146.526C3.36783 144.068 12.7477 140.789 23.1293 138.968C23.4025 138.877 23.5847 138.695 23.4936 138.422Z'
          fill='#781610'
        />
        <path
          d='M26.2256 140.971C26.1345 140.698 25.9524 140.607 25.6792 140.607C13.9316 142.793 3.64103 146.618 -2.73364 149.35V150.351C3.54996 147.619 14.0226 143.703 25.8613 141.518C26.1345 141.427 26.3167 141.154 26.2256 140.971Z'
          fill='#781610'
        />
        <path
          d='M28.9576 143.43C28.8665 143.157 28.6844 142.975 28.4112 143.066C15.1154 145.707 3.82316 150.169 -2.73364 153.083V154.085C3.7321 151.171 15.1154 146.618 28.5933 143.977C28.8665 143.977 29.0487 143.703 28.9576 143.43Z'
          fill='#781610'
        />
        <path
          d='M37.1536 150.989C37.0625 150.716 36.8804 150.624 36.6072 150.624C18.1207 154.722 4.0053 161.188 -2.73364 164.74V165.742C3.7321 162.372 18.0296 155.633 36.7893 151.535C37.0625 151.535 37.2447 151.262 37.1536 150.989Z'
          fill='#781610'
        />
        <path
          d='M39.8856 153.539C39.7945 153.265 39.6124 153.174 39.3392 153.174C18.9403 157.819 3.82316 165.104 -2.73364 168.656V169.657C3.54996 166.197 18.7581 158.729 39.5213 153.994C39.7945 153.994 39.9767 153.812 39.8856 153.539Z'
          fill='#781610'
        />
        <path
          d='M42.6176 156.089C42.5265 155.815 42.3444 155.724 42.0712 155.724C19.6688 160.915 3.64103 169.111 -2.73364 172.663V173.664C3.1857 170.295 19.3956 161.826 42.2533 156.544C42.5265 156.544 42.7087 156.362 42.6176 156.089Z'
          fill='#781610'
        />
        <path
          d='M50.8136 163.647C50.7225 163.374 50.5404 163.283 50.2672 163.283C20.6705 170.477 1.91076 181.678 -2.73364 184.683V185.776C0.817961 183.409 19.8509 171.661 50.4493 164.193C50.7225 164.102 50.9047 163.92 50.8136 163.647Z'
          fill='#781610'
        />
        <path
          d='M53.1814 166.743C53.4546 166.652 53.5456 166.47 53.5456 166.197C53.4545 165.924 53.2724 165.833 52.9992 165.833C20.3063 173.938 0.544761 186.596 -2.73364 188.781V189.874C-2.46044 189.692 17.6653 175.577 53.1814 166.743Z'
          fill='#781610'
        />
        <path
          d='M-2.27832 193.608C-2.18725 193.608 -2.09618 193.608 -2.00511 193.517C-1.82298 193.335 18.7581 178.582 56.0044 169.202C56.2776 169.111 56.3687 168.929 56.3687 168.656C56.2776 168.383 56.0955 168.291 55.8223 168.291C18.4849 177.671 -2.27831 192.606 -2.46045 192.697C-2.55152 192.697 -2.55151 192.788 -2.55151 192.879V193.335V193.426C-2.55151 193.517 -2.46045 193.608 -2.27832 193.608Z'
          fill='#781610'
        />
      </g>
    </g>
    <defs>
      <clipPath id='clip0_2308_2914'>
        <rect
          width='210'
          height='210'
          fill='white'
          transform='translate(0.669434)'
        />
      </clipPath>
    </defs>
  </svg>
)

export default Show
